<template>
  <a-space class="header-mar" size="10">
    <a-select placeholder="任务类型" v-model:value="taskType" class="width-120" >
      <a-select-option v-for="item in taskTypeDataList" :key="item.dictValue" :value="item.dictValue">
        {{ item.dictLabel }}
      </a-select-option>
    </a-select>
    <a-select placeholder="任务状态" v-model:value="taskStatus" class="width-120 ml10" :disabled="taskActiveKey === 'execution'" >
      <a-select-option value="1">待执行</a-select-option>
      <a-select-option value="2">执行中</a-select-option>
      <a-select-option value="3">已完成</a-select-option>
      <a-select-option value="4">已取消</a-select-option>
      <a-select-option value="5">已失败</a-select-option>
      <a-select-option value="6">已暂停</a-select-option>
    </a-select>
    <a-input placeholder="任务名，回车键查询" v-model:value="jobName" class="width-180 ml10" @pressEnter="refreshCurrentTabData"></a-input>

    <a-range-picker v-model:value="dataTime" format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="handleCustomDateChange" class="width-250 ml10 bf" v-if="taskActiveKey === 'all'"/>
    <a-button type="primary" class="ml10" @click="refreshCurrentTabData(true)"><SearchOutlined />查询</a-button>
    <a-button type="primary" class="ml10" @click="reset"><SyncOutlined />重置</a-button>
    <!-- <a-button type="primary" class="ml10" v-hasPermi="['task:import:report']" @click="openReportModal"><CloudUploadOutlined />上传报告</a-button> -->
    <a-dropdown v-hasPermi="['report:import']" :trigger="['click']">
      <a-button type="primary" class="ml10">
        <CloudUploadOutlined /> 上传报告
      </a-button>
      <template #overlay>
        <a-menu @click="handlePeriodSelect">
          <a-menu-item key="single">单次</a-menu-item>
          <a-menu-item key="daily">日报</a-menu-item>
          <a-menu-item key="weekly">周报</a-menu-item>
          <a-menu-item key="monthly">月报</a-menu-item>
          <a-menu-item key="quarterly">季报</a-menu-item>
          <a-menu-item key="yearly">年报</a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <a-button type="primary" class="ml10" v-hasPermi="['task:today:report']" @click="openDailyReportModal"><FileTextOutlined />生成报告</a-button>

  </a-space>

  <div class="plan-panel">
    <a-tabs v-model:activeKey="taskActiveKey" size="large">
      <a-tab-pane key="1" tab="近七日">
        <div class="recently-body">
          <!-- 表头（滚动时固定） -->
          <div class="recently-header">
            <div class="col-plan-time">计划/实际时间</div>
            <div class="col-status">任务状态</div>
            <div class="col-name">任务名称</div>
            <div class="col-type">任务类型</div>
            <div class="col-topic">主体名称</div>
            <div class="col-route">航线名称</div>
            <div class="col-dock">机场名称</div>
            <div class="col-media">媒体上传</div>
            <div class="col-action">操作</div>
          </div>

          <!-- 按日期分组的内容 -->
          <div v-for="group in sortedDateGroups" :key="group.date" class="date-group">
            <div class="date-group-title" @click="toggleGroup(group.date)">
              <CaretDownOutlined v-if="isExpanded(group.date)" class="expand-icon" />
              <CaretRightOutlined v-else class="expand-icon" />
              {{ group.date }}  ({{ group.tasks.length }})
            </div>
            <div v-show="isExpanded(group.date)">
              <div v-for="(task, idx) in group.tasks" :key="idx" class="task-row">
                <div class="col-plan-time">
                  <div>{{ formatTaskTime(task.execute_time) }}</div>
                  <div>{{ formatTaskTime(task.completed_time) }}</div>
                </div>
                <div class="col-status">
                  <span class="circle-icon" :style="{ backgroundColor: formatTaskStatus(task).color }"></span>
                  {{ formatTaskStatus(task).text }}
                  <a-tooltip v-if="!!task.code" placement="bottom" arrow-point-at-center>
                    <template #title>{{ getCodeMessage(task.code) }}</template>
                    <exclamation-circle-outlined class="ml5" :style="{ color: commonColor.WARN, fontSize: '14px' }" />
                  </a-tooltip>
                </div>
                <div class="col-name">
                  <template v-if="editingJobId === task.job_id">
                    <div class="edit-name-wrapper">
                      <a-input
                        ref="editInputRef"
                        v-model:value="editingJobName"
                        size="small"
                        @pressEnter="onSaveEdit(task)"
                        @keydown.esc="cancelEdit"
                        :disabled="savingJobName"
                        class="edit-name-input"
                      />
                      <CheckOutlined
                        class="edit-icon save-icon"
                        @click="onSaveEdit(task)"
                        :class="{ 'icon-disabled': savingJobName }"
                      />
                      <CloseOutlined
                        class="edit-icon cancel-icon"
                        @click="cancelEdit"
                      />
                    </div>
                  </template>
                  <template v-else>
                    <span :title="task.job_name || '未命名任务'">
                      {{ task.job_name || '未命名任务' }}
                    </span>
                  </template>
                </div>
                <div class="col-type">{{ formatTaskType(task) }}</div>
                <div class="col-topic" :title="task.portion">{{ task.portion || '--' }}</div>
                <div class="col-route" :title="task.file_name">{{ task.file_name || '--' }}</div>
                <div class="col-dock" :title="task.dock_name">{{ task.dock_name || '--' }}</div>
                <div class="col-media">
                  <div class="flex-display flex-align-center">
                    <span class="circle-icon" :style="{ backgroundColor: formatMediaTaskStatus(task).color }"></span>
                    {{ formatMediaTaskStatus(task).text }}
                    <div class="pl15">
                      {{ formatMediaTaskStatus(task).number }}
                      <a-tooltip v-if="formatMediaTaskStatus(task).status === MediaStatus.ToUpload" placement="bottom">
                        <template #title>立即上传</template>
                        <UploadOutlined class="ml5" :style="{ color: commonColor.BLUE, fontSize: '14px' }" @click="onUploadMediaFileNow(task.job_id)" />
                      </a-tooltip>
                    </div>
                  </div>

                </div>
                <div class="col-action">
                  <a-tooltip title="任务详情">
                    <FileTextOutlined class="fz18 c189" @click="openMessageData(task)" />
                  </a-tooltip>
                  <div v-if="task.status === TaskStatus.Success && task.media_count > 0 && formatMediaTaskStatus(task).status === MediaStatus.Success">
                    <a-tooltip title="报告模板">
                      <SnippetsOutlined class="fz18 c189 ml5" @click="openReport(task)"/>
                    </a-tooltip>
                  </div>
                  <div v-if="task.status === TaskStatus.Wait">
                    <a-popconfirm title="确定要删除任务吗？" ok-text="确定" cancel-text="取消" @confirm="() => onDeleteTask(task.job_id)" >
                      <a-tooltip title="删除" placement="right">
                        <delete-two-tone :style="{ fontSize: '20px' }" class="ml5" />
                      </a-tooltip>
                    </a-popconfirm>
                  </div>
                  <div v-if="task.status === TaskStatus.Carrying">
                    <a-popconfirm title="确定要挂起任务吗？" ok-text="确定" cancel-text="取消" @confirm="() => onSuspendTask(task.job_id)" >
                      <a-button type="primary" size="small" class="ml5">挂起</a-button>
                    </a-popconfirm>
                  </div>
                  <div v-if="task.status === TaskStatus.Paused">
                    <a-popconfirm title="确定要恢复任务吗？" ok-text="确定" cancel-text="取消" @confirm="() => onResumeTask(task.job_id)" >
                      <a-button type="primary" size="small" class="ml5">恢复</a-button>
                    </a-popconfirm>
                  </div>
                  <a-tooltip title="任务报告">
                    <FileSearchOutlined class="fz18 c189 ml5" @click="openReportView(task.job_id)" v-if="task.status === TaskStatus.Success && task.update_report_count > 0"/>
                  </a-tooltip>
                  <a-popconfirm title="确定要下载图片资源吗？" ok-text="确定" cancel-text="取消" @confirm="() => onExportZip(task.job_id)" >
                    <a-tooltip title="资源下载">
                      <DownloadOutlined class="fz18 c189 ml5" v-if="task.status === TaskStatus.Success && task.media_count > 0 && formatMediaTaskStatus(task).status === MediaStatus.Success"/>
                    </a-tooltip>
                  </a-popconfirm>

                  <a-tooltip title="告警" placement="top">
                    <AlertOutlined class="fz20 c189 ml5" @click="onAlarmTask(task)" v-if="task.status === TaskStatus.Success && task.alarm_count > 0"/>
                  </a-tooltip>

                  <a-tooltip title="名称编辑" placement="top">
                    <EditTwoTone class="fz20 ml5" @click="onNameEdit(task)"/>
                  </a-tooltip>
                </div>
              </div>
              <div v-if="group.tasks.length === 0" class="empty-row">暂无任务</div>
            </div>
          </div>
          <div v-if="Object.keys(recentlyTasksList).length === 0" class="empty-data">暂无任务数据</div>
        </div>
      </a-tab-pane>
      <a-tab-pane v-for="tab in commonTabs" :key="tab.key" :tab="tab.label">
        <div class="plan-panel-wrapper">
          <a-table class="plan-table" :columns="columns" :data-source="plansData.data" row-key="job_id" :pagination="paginationProp" :scroll="{ x: 300, y: 600 }" @change="refreshData">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'job_name'">
                <template v-if="editingJobId === record.job_id">
                  <div class="edit-name-wrapper">
                    <a-input
                      ref="editInputRef"
                      v-model:value="editingJobName"
                      size="small"
                      @pressEnter="onSaveEdit(record)"
                      @keydown.esc="cancelEdit"
                      :disabled="savingJobName"
                      class="edit-name-input"
                    />
                    <CheckOutlined
                      class="edit-icon save-icon"
                      @click="onSaveEdit(record)"
                      :class="{ 'icon-disabled': savingJobName }"
                    />
                    <CloseOutlined
                      class="edit-icon cancel-icon"
                      @click="cancelEdit"
                    />
                  </div>
                </template>
                <template v-else>
                  <span :title="record.job_name || '未命名任务'">
                    {{ record.job_name || '未命名任务' }}
                  </span>
                </template>
              </template>
              <template v-if="column.key === 'duration'">
                <div class="flex-row" style="white-space: pre-wrap">
                  <div>
                    <div>{{ formatTaskTime(record.begin_time) }}</div>
                    <div>{{ formatTaskTime(record.end_time) }}</div>
                  </div>
                  <div class="ml10">
                    <div>{{ formatTaskTime(record.execute_time) }}</div>
                    <div>{{ formatTaskTime(record.completed_time) }}</div>
                  </div>
                </div>
              </template>
              <template v-if="column.key === 'status'">
                <div class="flex-display flex-align-center">
                  <span class="circle-icon" :style="{backgroundColor: formatTaskStatus(record).color}"></span>
                  {{ formatTaskStatus(record).text }}
                  <a-tooltip v-if="!!record.code" placement="bottom" arrow-point-at-center >
                    <template #title>
                    <div>{{ getCodeMessage(record.code) }}</div>
                    </template>
                    <exclamation-circle-outlined class="ml5" :style="{color: commonColor.WARN, fontSize: '16px' }"/>
                  </a-tooltip>
                </div>
                <div v-if="record.status === TaskStatus.Carrying">
                  <a-progress :percent="record.progress || 0" />
                </div>
              </template>
              <template v-if="column.key === 'fileName'">
                <template v-if="!record.file_name">
                  <span>--</span>
                </template>
                <template v-else>
                  <span>{{ record.file_name }}</span>
                </template>
              </template>
              <template v-if="column.key === 'taskType'">{{ formatTaskType(record) }}</template>
              <template v-if="column.key === 'portion'"><span>{{ record.portion ? record.portion : '--' }}</span></template>
              <template v-if="column.key === 'media_upload'">
                <div class="flex-align-center">
                  <span class="circle-icon" :style="{backgroundColor: formatMediaTaskStatus(record).color}"></span>
                  {{ formatMediaTaskStatus(record).text }}
                </div>
                <div class="pl15">
                  {{ formatMediaTaskStatus(record).number }}
                  <a-tooltip v-hasPermi="['task:upload']" v-if="formatMediaTaskStatus(record).status === MediaStatus.ToUpload" placement="bottom" arrow-point-at-center >
                    <template #title>
                    <div>立即上传</div>
                    </template>
                    <UploadOutlined class="ml5" :style="{color: commonColor.BLUE, fontSize: '16px' }"  @click="onUploadMediaFileNow(record.job_id)"/>
                  </a-tooltip>
                </div>
              </template>
              <template v-if="column.key === 'action'">
                <div class="action-area">
                  <a-tooltip title="任务详情" v-hasPermi="['task:detail']">
                    <FileTextOutlined class="fz18 c189" @click="openMessageData(record)"/>
                  </a-tooltip>
                  <template v-if="taskActiveKey === 'execution'">
                    <a-popconfirm v-hasPermi="['task:delete']" title="确定要取消任务吗？" ok-text="确定" cancel-text="取消" @confirm="() => onCancelTask(record.job_id)">
                      <a-tooltip title="取消" placement="right">
                        <CloseCircleTwoTone :style="{ fontSize: '20px' }" class="ml5"/>
                      </a-tooltip>
                    </a-popconfirm>
                  </template>
                  <template v-else>
                    <template v-if="record.status === TaskStatus.Success && record.media_count > 0 && formatMediaTaskStatus(record).status === MediaStatus.Success">
                      <a-tooltip title="报告模板" v-hasPermi="['task:report:template']">
                        <SnippetsOutlined class="fz18 c189 ml5" @click="openReport(record)"/>
                      </a-tooltip>
                    </template>
                    <template v-if="record.status === TaskStatus.Wait">
                      <a-popconfirm v-hasPermi="['task:delete']" title="确定要删除任务吗？" ok-text="确定" cancel-text="取消" @confirm="() => onDeleteTask(record.job_id)" >
                        <a-tooltip title="删除" placement="right">
                          <delete-two-tone :style="{ fontSize: '20px' }" />
                        </a-tooltip>
                      </a-popconfirm>
                    </template>
                    <template v-if="record.status === TaskStatus.Carrying">
                      <a-popconfirm v-hasPermi="['task:carrying']" title="确定要挂起任务吗？" ok-text="确定" cancel-text="取消" @confirm="() => onSuspendTask(record.job_id)" >
                        <a-button type="primary" size="small">挂起</a-button>
                      </a-popconfirm>
                    </template>
                    <template v-if="record.status === TaskStatus.Paused">
                      <a-popconfirm v-hasPermi="['task:paused']" title="确定要恢复任务吗？" ok-text="确定" cancel-text="取消" @confirm="() => onResumeTask(record.job_id)" >
                        <a-button type="primary" size="small">恢复</a-button>
                      </a-popconfirm>
                    </template>
                    <a-tooltip title="任务报告">
                      <FileSearchOutlined class="fz18 c189 ml5" @click="openReportView(record.job_id)" v-if="record.status === TaskStatus.Success && record.update_report_count > 0"/>
                    </a-tooltip>
                    <a-popconfirm title="确定要下载图片资源吗？" ok-text="确定" cancel-text="取消" @confirm="() => onExportZip(record.job_id)" >
                      <a-tooltip title="资源下载">
                        <DownloadOutlined class="fz18 c189 ml5" v-if="record.status === TaskStatus.Success && record.media_count > 0 && formatMediaTaskStatus(record).status === MediaStatus.Success"/>
                      </a-tooltip>
                    </a-popconfirm>
                    <a-tooltip title="告警" placement="top">
                      <AlertOutlined class="fz20 c189 ml5" @click="onAlarmTask(record)" v-if="record.status === TaskStatus.Success && record.alarm_count > 0"/>
                    </a-tooltip>
                    <a-tooltip title="名称编辑" placement="top">
                      <EditTwoTone class="fz20 ml5" @click="onNameEdit(record)"/>
                    </a-tooltip>
                  </template>
                </div>
              </template>
            </template>
          </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>

  <div>
    <a-modal v-model:visible="messageVisible" title="任务详情" centered @cancel="messageVisible = false" :footer="null" :width="messageWidth">
        <div class="detail-container">
          <!-- 基本信息部分 -->
          <div class="detail-section left-section">
            <div class="section-title">基本信息</div>
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">任务名称：</span>
                <span class="detail-value">{{ previewMessage.job_name || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">开始时间-结束时间：</span>
                <span class="detail-value">{{ previewMessage.begin_time || '--' }}--{{ previewMessage.end_time || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">执行时间-完成时间：</span>
                <span class="detail-value">{{ previewMessage.execute_time || '--' }}--{{ previewMessage.completed_time || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">任务状态：</span>
                <span class="detail-value">{{ formatTaskStatus(previewMessage).text || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">任务类型：</span>
                <span class="detail-value">{{ formatTaskType(previewMessage) || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">航线名称：</span>
                <span class="detail-value">{{ previewMessage.file_name || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">专题应用：</span>
                <span class="detail-value">{{ previewMessage.portion || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">设备名称：</span>
                <span class="detail-value">{{ previewMessage.dock_name || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">设备编码：</span>
                <span class="detail-value" :title="previewMessage.dock_sn">{{ formatDeviceSn(previewMessage.dock_sn) || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">任务来源：</span>
                <span class="detail-value">{{ originEmus[previewMessage.origin] || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">告警图片：</span>
                <span class="detail-value">{{ previewMessage.alarm_count || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">媒体图片：</span>
                <span class="detail-value">{{ previewMessage.media_count || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">备注：</span>
                <span class="detail-value">{{ previewMessage.remark || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">地面高度：</span>
                <span class="detail-value">{{ previewMessage.rth_altitude || '--' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">失联动作：</span>
                <span class="detail-value">{{ previewMessage.type === 0 ? formatLostAction(previewMessage) : (previewMessage.type === 2 ? formatFlyLostAction(previewMessage) : '--') }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">创建人：</span>
                <span class="detail-value">{{ previewMessage.username || '--' }}</span>
              </div>
            </div>
          </div>
          <div class="detail-section" v-if="previewMessage.status === TaskStatus.Success">
            <div class="section-title right-section">
              任务轨迹
              <div class="play-controls">
                <a-button size="small" @click="startPlayback" :disabled="!hasTrajectory || isPlaying">播放</a-button>
                <a-button size="small" @click="pausePlayback" :disabled="!isPlaying">暂停</a-button>
                <a-button size="small" @click="resetPlayback" :disabled="!hasTrajectory">重置</a-button>
                <a-select size="small" v-model:value="playbackSpeed" style="width: 80px; margin-left: 8px;" @change="adjustSpeed">
                  <a-select-option :value="0.5">0.5x</a-select-option>
                  <a-select-option :value="1">1x</a-select-option>
                  <a-select-option :value="2">2x</a-select-option>
                </a-select>
              </div>
            </div>
            <div class="json-container">
              <div class="map" ref="mapRef"></div>
              <pre v-if="!flightDetailData">{{ formattedJson }}</pre>
            </div>
          </div>
        </div>
        <template #footer>
          <a-button @click="handleCancel">关闭</a-button>
        </template>
    </a-modal>

    <a-modal v-model:visible="uploadReportVisible" :title="`上传${periodTypeStatus[uploadReportState.time]}`" centered @ok="handleSubmit" @cancel="flyUploadCancel">
      <a-form ref="uploadReportRef" :model="uploadReportState" :rules="uploadReportRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" layout="horizontal" >
        <a-form-item label="报告名称" name="name">
          <a-input v-model:value="uploadReportState.name" placeholder="请输入报告名称" allow-clear />
        </a-form-item>

        <a-form-item label="报告版本号" name="version">
          <a-input v-model:value="uploadReportState.version" placeholder="报告版本号(命名格式：V1.0)" allow-clear />
        </a-form-item>

        <a-form-item label="报告类型" name="type">
          <a-select v-model:value="uploadReportState.type" placeholder="请选择报告类型" allow-clear >
            <a-select-option v-for="item in enabledTemplatesValue" :key="item.template_code" :value="item.template_code">{{ item.template_name }}</a-select-option>
          </a-select>
        </a-form-item>

        <!-- <a-form-item label="报告周期" name="time">
          <a-select v-model:value="uploadReportState.time" placeholder="请选择报告周期" @change="handleTimeChange">
            <a-select-option value="single">单次报告</a-select-option>
            <a-select-option value="daily">日报</a-select-option>
            <a-select-option value="weekly">周报</a-select-option>
            <a-select-option value="monthly">月报</a-select-option>
            <a-select-option value="quarterly">季报</a-select-option>
            <a-select-option value="yearly">年报</a-select-option>
          </a-select>
        </a-form-item> -->

        <a-form-item label="关联任务" name="wayline">
          <div style="display: flex; align-items: center;">
            <a-input
              v-model:value="uploadReportState.waylineName"
              placeholder="请选择关联任务(单次)或报告(周期)"
              readonly
              style="flex: 1; margin-right: 8px;"/>
            <a-button type="primary" size="small" @click="reportSelect">选择</a-button>
          </div>
        </a-form-item>

        <a-form-item label="报告附件" name="file">
          <a-upload v-model:file-list="uploadReportState.fileList" name="file" :custom-request="customUpload"
             :accept="'.pdf'" :before-upload="beforeUpload" @remove="handleRemove" :max-count="1">
            <a-button>
              <upload-outlined></upload-outlined>
              上传任务报告（只支持pdf格式）
            </a-button>
          </a-upload>
          <div v-if="uploadProgress > 0" style="margin-top: 8px;">
            <a-progress :percent="uploadProgress" :stroke-color="{
              '0%': '#108ee9',
              '100%': '#87d068',
            }" />
          </div>
          <div v-if="uploadReportState.file" style="margin-top: 8px; color: #52c41a;">
            ✓ 文件已上传: {{ uploadReportState.file.name }}
          </div>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal v-model:visible="reportChoseVisible" title="选择关联任务/报告" centered width="50%" @ok="choseSubmit" @cancel="choseCancel">
        <div v-if="uploadReportState.time === 'single'">
          <div class="display-flex m10">
            <div>
              <span>任务名称</span>
              <a-input v-model:value="taskNameValue" placeholder="任务名，回车键查询" @pressEnter="fetchPlanData(true)" style="width: 150px;" class="ml5"></a-input>
            </div>
            <div class="ml10">
              <span>项目</span>
              <a-select v-model:value="workspaceNameValue" placeholder="请选择项目" @change="handleWorkspaceChange" style="width: 150px;" class="ml5">
                <a-select-option v-for="item in workspaceList" :key="item.workspace_id" :value="item.workspace_id" >
                  {{ item.workspace_name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="ml10">
              <span>机场</span>
              <a-select v-model:value="dockNameValue" :placeholder="workspaceNameValue ? '请选择机场' : '请先选择项目'"  :disabled="!workspaceNameValue" @change="fetchPlanData(true)" style="width: 150px;" class="ml5">
                <a-select-option v-for="device in dockSnList" :key="device.device_sn" :value="device.device_sn">
                  {{ device.nickname }}
                </a-select-option>
              </a-select>
            </div>
            <a-button type="primary" @click="fetchPlanData(true)" class="ml10"><SearchOutlined />查询</a-button>
            <a-button class="ml10" @click="refreshPlanData"><SyncOutlined />重置</a-button>
          </div>
        </div>
        <div v-else>
          <div class="m10">
            <div class="display-flex">
              <div>
                <span>报告名称</span>
                <a-input v-model:value="reportNameValue" placeholder="报告名，回车键查询" @pressEnter="fetchChoseReportData(true)" style="width: 150px;" class="ml5"></a-input>
              </div>
              <div class="ml10">
                <span>时间</span>
                <a-range-picker v-model:value="reportDataTime" format="YYYY-MM-DD" @change="fetchChoseReportData(true)" style="width: 250px;" class="ml5"/>
              </div>
              <a-button type="primary" @click="fetchChoseReportData(true)" class="ml10"><SearchOutlined />查询</a-button>
              <a-button class="ml10" @click="refreshChoseReport"><SyncOutlined />重置</a-button>
            </div>
          </div>
        </div>
      <div>
        <a-table
          :columns="choseColumns"
          :data-source="choseData"
          :pagination="choseReportPagination"
          @change="refreshReportData"
          :row-selection="rowSelection"
          row-key="id"
          :scroll="{ y: 400 }">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'duration'">{{ formatTimestamp(record.executeTime) }}</template>
          <template v-if="column.key === 'portion'">{{ record.portion ? record.portion : '--' }}</template>
        </template>
      </a-table>
      </div>
    </a-modal>
  </div>

  <div>
    <a-modal v-model:visible="reportListVisible" title="任务报告列表" centered width="1200px">
      <a-table :columns="reportColumns" :data-source="reportListData" row-key="job_id"
        :pagination="reportPaginationProp" :scroll="{ x: '100%', y: 600 }" @change="refreshReportModalData">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'status'">{{ reportStatus[record.status] }}</template>
          <template v-if="column.key === 'periodType'">{{ periodTypeStatus[record.period_type] }}</template>
          <template v-if="column.key === 'action'">
            <a-tooltip title="预览">
              <EyeOutlined @click="openPdfView(record)" :style="{color: commonColor.BLUE, fontSize: '18px' }"/>
            </a-tooltip>
            <a-tooltip title="下载">
              <DownloadOutlined @click="reportDownload(record)" :style="{color: commonColor.BLUE, fontSize: '18px', marginLeft: '10px' }"/>
            </a-tooltip>
          </template>
        </template>
      </a-table>

      <template #footer>
        <a-button type="primary" @click="closeReportList">关闭</a-button>
      </template>
    </a-modal>
    <a-modal v-model:visible="previewVisible" title="报告预览" centered width="60%" :footer="null" :body-style="{ padding: 0 }" >
      <PDFPreview :pdf-url="previewUrl" :style="{ height: '85vh' }" />
    </a-modal>
  </div>

  <div>
    <a-modal class="tra-image-modal" v-model:visible="previewModalVisible" title="图片预览" :footer="null" width="800px" centered @cancel="previewModalVisible = false">
      <div style="text-align: center;">
        <img :src="previewImageUrl" style="max-width: 100%; max-height: 70vh;" alt="预览图片" />
      </div>
    </a-modal>
  </div>

  <div>
    <a-modal v-model:visible="reportVisible" :footer="null" width="80%">
      <div class="report-containers">
        <div class="report-item width-25">
          <div class="report-title mb10">模板选择</div>
          <div class="mb10 display-flex">
            <span :style="{ marginRight: '10px', marginLeft: '10px' }">模板分类:</span>
            <a-tree-select
              v-model:value="selectedCategoryValue"
              :tree-data="reportTreeData"
              :field-names="{ children: 'children', label: 'categoryName', value: 'categoryId' }"
              placeholder="请选择分类"
              allow-clear
              tree-default-expand-all
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              style="width: 200px"
              @change="onTreeSelectChange"
            />
            <a-space :size="[0, 8]" wrap>
              <a-checkable-tag
                v-for="(tag, index) in reportTags"
                :key="tag.categoryId"
                :value="tag.categoryId"
                v-model:checked="selectTags[index]"
                @change="checked => handleChange(tag, checked)"
              >
                {{ tag.categoryName }}
              </a-checkable-tag>
            </a-space>
          </div>
          <div class="template-overflow">
            <div class="report-card">
              <div v-for="item in modelList" :key="item.template_code" class="template-card" @click="selectTemplate(item)"
                 :class="{ 'template-card-active': selectedTemplateCode === item.template_code }">
                <div class="template-left">
                  <div class="template-thumb">
                    <div class="thumb-placeholder">
                      <div v-if="!item.url" >
                        <span>{{ item.template_category_name }}模板</span>
                      </div>
                      <img :src="item.url" v-else style="width: 60px; height: 100%;"/>
                    </div>
                  </div>
                </div>
                <div class="template-right">
                  <div class="template-name">{{ item.template_name }}</div>
                  <div class="template-desc">{{ item.description || '暂无描述' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="report-item width-25">
          <div class="report-title mb30">报告信息</div>
          <div>
            <div class="module-title">基本信息</div>
            <div class="form-item">
              <label class="form-label">报告名称：</label>
              <div class="form-control">
                <a-input v-model:value="reportName" />
              </div>
            </div>
            <div class="form-item">
              <label class="form-label">版本号：</label>
              <div class="form-control">
                <a-input v-model:value="reportVersion" placeholder="请输入报告版本号(命名格式：V1.0)"/>
              </div>
            </div>
            <div class="form-item">
              <label class="form-label">专题应用：</label>
              <div class="form-control">
                <!-- <a-input v-model:value="specializedApplication" disabled/> -->
                <a-tree-select v-model:value="selectedTopicValue" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" @change="handleTopicChange"
                  :tree-data="specialTopicList" placeholder="请选择关联专题" style="width: 276px;" allow-clear/>
              </div>
            </div>
            <div class="form-item">
              <label class="form-label">巡查对象：</label>
              <div class="form-control">
                <a-input v-model:value="inspectionTarget" disabled/>
              </div>
            </div>
            <div class="form-item">
              <label class="form-label">执行机场：</label>
              <div class="form-control">
                <a-input v-model:value="executiveAirport" disabled/>
              </div>
            </div>
          </div>
          <div class="mt20">
            <div class="module-title">生成设置</div>
            <div class="form-item">
              <label class="form-label">报告方式：</label>
              <div class="form-control">
                <a-radio-group v-model:value="reportingMethod" name="radioGroup">
                  <a-radio value="1">单次</a-radio>
                </a-radio-group>
              </div>
            </div>
            <div class="form-item">
              <label class="form-label">生成形式：</label>
              <div class="form-control">
                <a-radio-group v-model:value="generativeForm" name="radioGroup">
                  <a-radio value="1">立即生成</a-radio>
                </a-radio-group>
              </div>
            </div>
          </div>
          <div class="button-container mt20">
            <a-button type="primary" :disabled="!selectedTemplateCode" @click="handlePreview">预览</a-button>
          </div>
        </div>
        <div class="report-item width-38">
          <div class="report-title">报告预览</div>
          <div class="preview-container">
            <div v-if="previewLoading" class="preview-loading">
              <a-spin size="large" />
              <div class="loading-text">正在生成预览...</div>
            </div>
            <div v-else-if="previewHtml" class="preview-content" v-html="previewHtml"></div>
            <div v-else class="preview-empty">
              请选择模板并点击"预览"生成报告预览
            </div>
          </div>

          <div class="button-container mt20">
            <a-button type="primary" class="mr10" @click="handleGeneratePDF" :disabled="!selectedTemplateCode">
            <span v-if="generateLoading"><a-spin size="small" /> 生成中...</span>
            <span v-else>生成</span>
          </a-button>
            <a-button type="primary" class="mr10" @click="reportVisible = false">取消</a-button>
          </div>
        </div>
      </div>
    </a-modal>

    <a-modal v-model:visible="dailyReportVisible" title="生成日报" :width="'800px'" centered :okText="submitButtonText" @ok="handleRepertSubmit" @cancel="dailyReportCancel" :ok-button-props="{ disabled: !isFormComplete }">
      <a-tabs v-model:activeKey="reportActiveKey">
        <a-tab-pane key="daily" tab="日报">
          <a-form ref="dailyReportRef" :model="dailyReportState" :rules="dailyReportRules" layout="horizontal">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-item label="设备" name="device">
                  <a-select v-model:value="dailyReportState.device" placeholder="请选择设备" @change="handleDeviceChange">
                    <a-select-option v-for="device in dockSnList" :key="device.device_sn" :value="device.device_sn">
                      {{ device.nickname }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="日期" name="time">
                  <a-date-picker v-model:value="dailyReportState.time" placeholder="请选择日期" value-format="YYYY-MM-DD" @change="handleDateChange" allow-clear class="width-100"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-item label="名称" name="name">
                  <a-input v-model:value="dailyReportState.name" placeholder="请输入报告名称" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="版本" name="version">
                  <a-input v-model:value="dailyReportState.version" placeholder="请输入报告版本号(命名格式：V1.0)" allow-clear />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-item label="全景影像" name="task">
                  <div class="flex-display flex-align-center">
                    <a-input v-model:value="dailyReportState.quanJobName" placeholder="请先选择日期和设备，然后选择全景任务(单选)" readonly class="flex-1 mr8" />
                    <a-button type="primary" size="small" @click="selectTask" :disabled="!dailyReportState.time || !dailyReportState.device">选择</a-button>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-item label="场景任务" name="other">
                  <div v-for="(group, index) in otherJobsBySpecialApp" :key="group.specialAppId" class="special-app-group mb5" >
                  <div class="group-header">
                    <span class="group-title">{{ group.specialAppName }}</span>
                    <a-button type="danger" size="small" danger @click="removeSpecialAppGroup(index)" >
                      <DeleteOutlined />
                    </a-button>
                  </div>
                  <div class="group-jobs">
                    <a-tag v-for="job in group.jobs" :key="job.jobId || job.id" closable @close="removeJobFromGroup(index, job)" >
                      {{ job.name }}
                    </a-tag>
                  </div>
                </div>
                  <a-button type="primary" size="small" @click="openSpecialAppJobDialog" :disabled="!dailyReportState.time || !dailyReportState.device">+添加专题应用任务</a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-tab-pane>
        <a-tab-pane key="weekly" tab="周报">
          <a-form ref="weeklyReportRef" :model="weeklyReportState" :rules="weeklyReportRules" layout="horizontal">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-item label="日期范围" name="time">
                  <a-range-picker v-model:value="weeklyReportState.time" placeholder="请选择日期" value-format="YYYY-MM-DD" allow-clear class="width-100"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="项目" name="workspace">
                  <a-select v-model:value="weeklyReportState.workspace" placeholder="请选择项目">
                    <a-select-option v-for="item in workspaceList" :key="item.workspace_id" :value="item.workspace_id">
                      {{ item.workspace_name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-item label="名称" name="name">
                  <a-input v-model:value="weeklyReportState.name" placeholder="请输入报告名称" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="版本号" name="version">
                  <a-input v-model:value="weeklyReportState.version" placeholder="请输入版本号" allow-clear />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-item label="周报模板" name="template">
                  <a-select v-model:value="weeklyReportState.template" placeholder="请选择周报模板">
                    <a-select-option v-for="item in templateList" :key="item.template_code" :value="item.template_code">
                      {{ item.template_name || item.templateName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-tab-pane>
      </a-tabs>
    </a-modal>

    <!-- 专题应用任务选择弹窗 -->
    <a-modal
      v-model:visible="specialAppJobDialogVisible"
      title="选择专题应用和任务"
      width="900px"
      centered
      @ok="confirmSpecialAppJob"
      @cancel="specialAppJobDialogVisible = false"
      :confirm-loading="specialAppJobConfirmLoading"
    >
      <div class="special-app-dialog-body">
        <div class="special-app-section">
          <div class="section-title">
            选择专题应用
            <span class="subtitle">（只能选择最后一层，且appCode不能为空）</span>
          </div>
          <a-tree-select
            v-model:value="selectedSpecialAppId"
            :tree-data="specialAppTreeData"
            :field-names="{ children: 'children', label: 'title', value: 'key' }"
            placeholder="请选择专题应用"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            @change="handleSpecialAppSelectChange"
            :getPopupContainer="triggerNode => triggerNode.parentNode"
          />
          <div v-if="currentSpecialApp" class="selected-app-info">
            已选择：{{ currentSpecialApp.name }}（{{ currentSpecialApp.appCode }}）
          </div>
        </div>
        <div class="job-section">
          <div class="section-title">
            选择任务
            <span class="subtitle">
              （{{ filterJobBySpecialApp ? `仅显示专题应用: ${currentSpecialApp.name} 的任务` : '显示所有任务' }}）
            </span>
          </div>
          <a-table
            :columns="specialAppJobColumns"
            :data-source="filteredSpecialAppJobList"
            :loading="specialAppJobDialogLoading"
            :pagination="specialAppJobPagination"
            row-key="id"
            :row-selection="{ selectedRowKeys: selectedSpecialAppJobKeys, onChange: onSpecialAppJobSelectChange }"
            @change="handleSpecialAppJobTableChange"
            :scroll="{ y: 350 }"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'name'">
                {{ record.name }}
              </template>
              <template v-else-if="column.key === 'dockName'">
                {{ record.dockName || '--' }}
              </template>
              <template v-else-if="column.key === 'status'">
                <a-tag :color="getStatusColor(record.status)">
                  {{ getStatusText(record.status) }}
                </a-tag>
              </template>
            </template>
          </a-table>
        </div>
      </div>
    </a-modal>

    <a-modal v-model:visible="taskVisible" title="选择任务（单选）" centered width="70%" @ok="choseTaskSubmit" @cancel="choseTaskCancel">
      <a-table :columns="taskColumns" :data-source="taskData" @change="refreshTaskData" :pagination="taskReportPagination" :row-selection="rowTaskSelection" row-key="job_id" :scroll="{ y: 400 }">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'fileName'">{{ record.file_name || '--' }}</template>
          <template v-if="column.key === 'media_upload'">
            <div class="flex-display flex-align-center">
              <span class="circle-icon" :style="{backgroundColor: formatMediaTaskStatus(record).color}"></span>
              {{ formatMediaTaskStatus(record).text }}
              {{ formatMediaTaskStatus(record).number }}
            </div>
          </template>
          <template v-if="column.key === 'dock_sn'">
            <span :title="record.dock_sn">{{ formatDeviceSn(record.dock_sn) }}</span>
          </template>
        </template>
      </a-table>
    </a-modal>
  </div>

  <div>
    <mediaContent ref="mediaContentRef" :jobId="taskJobId" />
  </div>

</template>

<script setup lang="ts">
import { reactive, ref } from '@vue/reactivity'
import { message } from 'ant-design-vue'
import { TableState } from 'ant-design-vue/lib/table/interface'
import { computed, nextTick, onMounted, onUnmounted, watch } from 'vue'
import {
  deleteTask, updateTaskStatus, UpdateTaskStatus, Task, uploadMediaFileNow, downloadZip, WaylinePageRequest,
  getWaylineTask, dataVer, dataVerification, taskTrajectory, getWaylineTaskList,
  cancelPendingTask
} from '/@/api/wayline'
import { useMyStore } from '/@/store'
import { ELocalStorageKey, ERouterName } from '/@/types/enums'
import { useFormatTask } from './use-format-task'
import { TaskStatus, TaskProgressInfo, TaskProgressStatus, TaskProgressWsStatusMap, MediaStatus, MediaStatusProgressInfo, TaskMediaHighestPriorityProgressInfo } from '/@/types/task'
import { useTaskWsEvent } from './use-task-ws-event'
import { getErrorMessage } from '/@/utils/error-code/index'
import { commonColor } from '/@/utils/color'
import { ExclamationCircleOutlined, UploadOutlined, DeleteTwoTone, PlusOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons-vue'
import { downloadFile } from '/@/utils/common'
import * as Cesium from 'cesium'
import { formatDeviceSn, getDevice, getWaylineJobEdit, getWorkSpaceList } from '/@/api/manage'
import { Device } from '/@/types/device'
import { useRouter } from 'vue-router'
import svgIcon from '/@/components/svgIcon.vue'
import moment from 'moment'
import type { Moment } from 'moment'
import { useDefaultCesium } from '/@/hooks/Cesium'
import DrawTool from '/@/hooks/Cesium/draw'
import { getDailyData, getDictDataList, getExportPDFReport, getGenerateHTML, getTemplatesList, getTemplatesListTree, getTemplatesTree } from '/@/api/algCode'
import { getFolderList } from '/@/api/media'
import { getFlyTaskList, getVoidReport } from '/@/api/report'
import { getObjectKey } from '/@/api/disposition'
import { reviewScheduledTasks, saveTaskReview, getRecentlyTasks } from '/@/api/flightPlan'
import { exportTemplateWeekReport, getEnabledTemplates, getPlanPage, getReportPage, getUploadReport } from '/@/api/insp-report'
import PDFPreview from '/@/components/pdfjs.vue'
import { getImageJobShowTrack } from '/@/api/insp/insp-flightTrajectory'
import PanoramicPhotos from '/@/assets/icons/panoramicPhotos.svg'
import mediaContent from '/@/components/media/media-content-alarm.vue'
import { getAlarmPage } from '/@/api/alarm'
import { getAllSpecialData, getAllSpecialTree } from '/@/api/insp/insp-regulations'
import dronePhotos from '/@/assets/icons/drone.png'
import { Dayjs } from 'dayjs'

interface SpecialTreeNode {
  id: number;
  code: string;
  name: string;
  parentId: number;
  parentName: string | null;
  status: number;
  sort: number;
  remark: string | null;
  createBy: string | null;
  createTime: string;
  updateBy: string | null;
  updateTime: string;
  children?: SpecialTreeNode[];
}

interface TreeSelectNode {
  key: number;
  title: string;
  value: number;
  children?: TreeSelectNode[];
  isLeaf?: boolean;
  rawData?: SpecialTreeNode;
}

interface SpecialThirdNode {
  id: number;
  name: string;
  category: string;
}

const store = useMyStore()

const router = useRouter()
const taskType = ref(null)
const taskStatus = ref(null)
const jobName = ref('')

const previewVisible = ref(false)
const previewUrl = ref('')
const enabledTemplatesValue = ref([])

const taskActiveKey = ref('1')

// 编辑任务名称相关
const editingJobId = ref<string | null>(null) // 正在编辑的任务ID
const editingJobName = ref('') // 当前编辑框中的值
const savingJobName = ref(false) // 保存中的加载状态
const editInputRef = ref<any>(null)

const commonTabs = [
  { key: 'yesterday', label: '昨日' },
  { key: 'today', label: '今日' },
  { key: 'all', label: '全部' },
  { key: 'execution', label: '待执行' }
]

const originEmus = {
  1: '小程序',
  2: 'APP',
  3: 'PC',
  4: '其他'
}

const openPdfView = (record) => {
  if (!record.url) {
    message.error('PDF文件不存在')
    return
  }

  let pdfUrl = record.url
  if (!pdfUrl.startsWith('http') && !pdfUrl.startsWith('https')) {
    pdfUrl = `${import.meta.env.VITE_API_BASE_URL || ''}${pdfUrl}`
  }

  // 先关闭预览再重新打开，确保完全刷新
  previewVisible.value = false
  nextTick(() => {
    previewUrl.value = pdfUrl
    previewVisible.value = true
  })
}

const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const verDate = new Date().toISOString().split('T')[0]
// const verDate = '2025-08-19'
const exportData = ref<dataVerification | null>(null)
const dataVerify = async () => {
  const res = await dataVer(workspaceId, verDate)
  if (res && res.code === 0) {
    exportData.value = res.data || null
  }
}

const paginationProp = reactive({
  pageSizeOptions: ['10', '20', '50', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
  pageSize: 10,
  current: 1,
  total: 0,
  showTotal: (total: number) => `总计 ${total} 条`
})

// 范围类型指定为联合类型
const rangeType = ref<'yesterday' | 'today' | 'custom' | ''>('')
const dataTime = ref<[Moment | null, Moment | null]>([null, null])

const handleCustomDateChange = (dates: [Moment | null, Moment | null]) => {
  dataTime.value = dates
  taskActiveKey.value = 'all'
  refreshCurrentTabData(true)
}

const columns = [
  { title: '计划/实际时间', dataIndex: 'duration', key: 'duration', width: 200, align: 'center' },
  { title: '任务状态', key: 'status', align: 'center' },
  { title: '任务名称', width: 200, dataIndex: 'job_name', key: 'job_name', ellipsis: true, align: 'center' },
  { title: '任务类型', dataIndex: 'taskType', key: 'taskType', align: 'center' },
  { title: '主体名称', dataIndex: 'portion', key: 'portion', align: 'center' },
  { title: '航线名称', dataIndex: 'file_name', key: 'fileName', align: 'center' },
  { title: '机场名称', dataIndex: 'dock_name', key: 'dock_name', ellipsis: true, align: 'center' },
  { title: '媒体上传', width: 200, key: 'media_upload', align: 'center' },
  { title: '操作', width: 250, align: 'center', key: 'action' }
]
type Pagination = TableState['pagination']

const plansData = reactive({
  data: [] as Task[]
})

const { formatTaskType, formatTaskTime, formatLostAction, formatTaskStatus, formatMediaTaskStatus, formatFlyLostAction } = useFormatTask()

// 设备任务执行进度更新
function onTaskProgressWs (data: TaskProgressInfo) {
  const { bid, output } = data
  if (output) {
    const { status, progress } = output || {}
    const taskItem = plansData.data.find(task => task.job_id === bid)
    if (!taskItem) return
    if (status) {
      taskItem.status = TaskProgressWsStatusMap[status]
      // 执行中，更新进度
      if (status === TaskProgressStatus.Sent || status === TaskProgressStatus.inProgress) {
        taskItem.progress = progress?.percent || 0
      } else if ([TaskProgressStatus.Rejected, TaskProgressStatus.Canceled, TaskProgressStatus.Timeout, TaskProgressStatus.Failed, TaskProgressStatus.OK].includes(status)) {
        // getPlans()
        fetchData(true)
      }
    }
  }
}

// 媒体上传进度更新
function onTaskMediaProgressWs (data: MediaStatusProgressInfo) {
  const { media_count: mediaCount, uploaded_count: uploadedCount, job_id: jobId } = data
  if (isNaN(mediaCount) || isNaN(uploadedCount) || !jobId) {
    return
  }
  const taskItem = plansData.data.find(task => task.job_id === jobId)
  if (!taskItem) return
  if (mediaCount === uploadedCount) {
    taskItem.uploading = false
  } else {
    taskItem.uploading = true
  }
  taskItem.media_count = mediaCount
  taskItem.uploaded_count = uploadedCount
}

function onoTaskMediaHighestPriorityWS (data: TaskMediaHighestPriorityProgressInfo) {
  const { pre_job_id: preJobId, job_id: jobId } = data
  const preTaskItem = plansData.data.find(task => task.job_id === preJobId)
  const taskItem = plansData.data.find(task => task.job_id === jobId)
  if (preTaskItem) {
    preTaskItem.uploading = false
  }
  if (taskItem) {
    taskItem.uploading = true
  }
}

function getCodeMessage (code: number) {
  return getErrorMessage(code) + `（code: ${code}）`
}

const selectedInfo = computed(() => store.state.selectedDeviceInfo)

watch(
  () => store.state.selectedDeviceInfo,
  (newInfo) => {
    if (newInfo.dock_sn || newInfo.device_sn) {
      refreshCurrentTabData(true)
    }
  },
  { immediate: true, deep: true }
)

const fetchData = async (resetPage = false, customStartTime?: string, customEndTime?: string) => {
  if (resetPage) {
    paginationProp.current = 1
  }

  let start_time = ''
  let end_time = ''

  if (customStartTime !== undefined && customEndTime !== undefined) {
    start_time = customStartTime
    end_time = customEndTime
  } else {
    // 对 dataTime 进行规范化
    const [startMoment, endMoment] = dataTime.value
    start_time = startMoment ? startMoment.format('YYYY-MM-DD') + ' 00:00:00' : ''
    end_time = endMoment ? endMoment.format('YYYY-MM-DD') + ' 23:59:59' : ''
  }

  const param: any = {
    task_type: taskType.value,
    job_name: jobName.value,
    dock_sn: selectedInfo.value.nodeType === 'dock' ? selectedInfo.value.dock_sn : '',
    device_sn: selectedInfo.value.nodeType === 'device' ? selectedInfo.value.device_sn : '',
    start_time,
    end_time
  }

  if (taskActiveKey.value === 'execution') {
    param.status = 1
  } else if (taskStatus.value) {
    param.status = taskStatus.value
  }

  const queryParam: WaylinePageRequest = {
    page: paginationProp.current,
    page_size: paginationProp.pageSize,
    param
  }
  const res = await getWaylineTask(queryParam)
  if (res && res.code === 0) {
    plansData.data = res.data.list
    console.log('res.data.list', res.data.list)
    paginationProp.total = res.data.pagination.total || 0
  }
}

const dockSnList = ref<Device[]>([])

async function getDockSN () {
  try {
    const param = {
      domains: [3]
    }
    const res = await getDevice(param)
    if (res && res.code === 0) {
      dockSnList.value = res.data
    }
  } catch (e) {
    console.log('获取设备列表时发生异常:', e)
  }
}

useTaskWsEvent({
  onTaskProgressWs,
  onTaskMediaProgressWs,
  onoTaskMediaHighestPriorityWS,
})

function refreshData (page: Pagination) {
  paginationProp.current = page?.current!
  paginationProp.pageSize = page?.pageSize!
  refreshCurrentTabData(false)
}

// 取消
async function onCancelTask (jobId: string) {
  const { code } = await cancelPendingTask(jobId)
  if (code === 0) {
    message.success('取消成功')
    fetchData(true)
  }
}

// 删除任务
async function onDeleteTask (jobId: string) {
  const { code } = await deleteTask(workspaceId, {
    job_id: jobId
  })
  if (code === 0) {
    message.success('删除成功')
    fetchData(true)
  }
}

// 挂起任务
async function onSuspendTask (jobId: string) {
  const { code } = await updateTaskStatus(workspaceId, {
    job_id: jobId,
    status: UpdateTaskStatus.Suspend
  })
  if (code === 0) {
    message.success('挂起成功')
    fetchData(true)
  }
}

// 解除挂起任务
async function onResumeTask (jobId: string) {
  const { code } = await updateTaskStatus(workspaceId, {
    job_id: jobId,
    status: UpdateTaskStatus.Resume
  })
  if (code === 0) {
    message.success('恢复成功')
    fetchData(true)
  }
}

// 立即上传媒体
async function onUploadMediaFileNow (jobId: string) {
  const { code } = await uploadMediaFileNow(workspaceId, jobId)
  if (code === 0) {
    message.success('上传成功')
    fetchData(true)
  }
}

const loading = ref({})
const onExportZip = async (jobId: string) => {
  try {
    loading.value[jobId] = true
    const res = await downloadZip(workspaceId, jobId)
    const blob: Blob = res.data
    if (blob && blob.type === 'application/json') {
      const text = await blob.text()
      try {
        const obj = JSON.parse(text)
        message.error(obj.message || '导出失败')
      } catch (e) {
        message.error('导出失败')
      }
      return
    }
    let filename = `${jobId || 'export'}.zip`
    const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition']
    if (disposition) {
      const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition)
      const rawName = (match && (match[1] || match[2])) || ''
      if (rawName) {
        try {
          filename = decodeURIComponent(rawName)
        } catch {
          filename = rawName
        }
      }
    }
    downloadFile(blob, filename)
  } finally {
    loading.value[jobId] = false
  }
}

const taskTypeDataList = ref<any[]>([])

async function loadTaskTypeDataList () {
  const res = await getDictDataList('route_task_type')
  if (res && res.code === 200) {
    taskTypeDataList.value = res.data || []
  }
}

const taskRoute = () => {
  router.push({
    name: ERouterName.CREATE_PLAN
  })
}

const recentlyTasksList = ref({})

const getLast7DaysRange = () => {
  const end = moment().endOf('day')
  const start = moment().subtract(6, 'days').startOf('day')
  return {
    start_time: start.format('YYYY-MM-DD HH:mm:ss'),
    end_time: end.format('YYYY-MM-DD HH:mm:ss')
  }
}

const fetchRecentlyTask = async () => {
  const defaultRange = getLast7DaysRange()
  const start = moment(defaultRange.start_time)
  const end = moment(defaultRange.end_time)

  const param = {
    start_time: start.format('YYYY-MM-DD HH:mm:ss'),
    end_time: end.format('YYYY-MM-DD HH:mm:ss'),
    task_type: taskType.value,
    status: taskStatus.value,
    job_name: jobName.value,
    dock_sn: selectedInfo.value.nodeType === 'dock' ? selectedInfo.value.dock_sn : '',
    device_sn: selectedInfo.value.nodeType === 'device' ? selectedInfo.value.device_sn : '',
  }
  const res = await getRecentlyTasks(param)
  if (res && res.code === 0) {
    recentlyTasksList.value = res.data
  }
}

// 监听筛选条件变化，当在“近七日”tab时刷新
watch([taskType, taskStatus, jobName], () => {
  if (taskActiveKey.value !== '1') {
    refreshCurrentTabData(true)
  } else {
    // 近七日也支持筛选条件变化刷新
    fetchRecentlyTask()
  }
})

// 切换tab时刷新近七日数据
watch(taskActiveKey, () => {
  paginationProp.current = 1
  refreshCurrentTabData(true)
})

const sortedDateGroups = computed(() => {
  // 获取所有日期并降序排序（最新的在前）
  const dates = Object.keys(recentlyTasksList.value).sort((a, b) => b.localeCompare(a))
  // 转换为 [{ date, tasks }, ...] 格式
  return dates.map(date => ({
    date,
    tasks: recentlyTasksList.value[date]
  }))
})

const onNameEdit = (task) => {
  console.log('onNameEdit', task)
  editingJobId.value = task.job_id || ''
  editingJobName.value = task.job_name || ''
  nextTick(() => {
    if (editInputRef.value) {
      editInputRef.value.focus()
      editInputRef.value.select()
    }
  })
}

const onSaveEdit = async (task) => {
  if (savingJobName.value || editingJobId.value !== task.job_id) return

  const newName = editingJobName.value.trim()

  if (!newName) {
    message.warning('任务名称不能为空')
    cancelEdit()
    return
  }

  if (newName === task.job_name) {
    cancelEdit()
    return
  }

  savingJobName.value = true
  try {
    const param = {
      job_id: editingJobId.value,
      job_name: editingJobName.value
    }
    const res = await getWaylineJobEdit(param)
    if (res.code === 0) {
      refreshCurrentTabData(true)
      cancelEdit()
    } else {
      message.error(res?.msg || '更新失败')
    }
  } catch (error) {
    console.error('更新任务名称失败:', error)
  } finally {
    savingJobName.value = false
  }
}

const cancelEdit = () => {
  editingJobId.value = null
  editingJobName.value = ''
}

const expandedGroups = ref<Record<string, boolean>>({})

const isExpanded = (date: string): boolean => {
  return expandedGroups.value[date] !== false // 默认展开
}

const toggleGroup = (date: string) => {
  if (expandedGroups.value[date] === undefined) {
    expandedGroups.value[date] = true
  }
  expandedGroups.value[date] = !expandedGroups.value[date]
}

watch(sortedDateGroups, (newGroups) => {
  newGroups.forEach(group => {
    if (expandedGroups.value[group.date] === undefined) {
      expandedGroups.value[group.date] = true
    }
  })
}, { immediate: true })

// 根据当前激活的 Tab 刷新数据
const refreshCurrentTabData = (resetPage = false) => {
  if (taskActiveKey.value === '1') {
    fetchRecentlyTask()
    return
  }

  if (resetPage) {
    paginationProp.current = 1
  }

  if (taskActiveKey.value === 'yesterday') {
    const start = moment().subtract(1, 'day').startOf('day')
    const end = moment().subtract(1, 'day').endOf('day')
    fetchData(false, start.format('YYYY-MM-DD HH:mm:ss'), end.format('YYYY-MM-DD HH:mm:ss'))
  } else if (taskActiveKey.value === 'today') {
    const start = moment().startOf('day')
    const end = moment()
    fetchData(false, start.format('YYYY-MM-DD HH:mm:ss'), end.format('YYYY-MM-DD HH:mm:ss'))
  } else if (taskActiveKey.value === 'all') {
    fetchData(false)
  } else if (taskActiveKey.value === 'execution') {
    fetchData(false)
  }
}

const reset = () => {
  taskType.value = null
  taskStatus.value = null
  jobName.value = ''

  if (taskActiveKey.value === 'all') {
    dataTime.value = [null, null]
    rangeType.value = ''
    store.commit('SET_SELECTED_DEVICE_INFO', {
      dock_sn: '',
      device_sn: '',
      nodeType: 'dock'
    })
  }

  refreshCurrentTabData(true)
}

const modalVisible = ref(false)
const mapRef = ref(null)
const flightDetailData = ref<any>(null)
const viewer = ref<Cesium.Viewer|null>(null)
const drawTool = ref<DrawTool | null>(null)
const polylineEntity = ref<Cesium.Entity | null>(null)
const pointArrEntity = ref<Cesium.Entity[] | null>([])

const formattedJson = computed(() => {
  if (!flightDetailData.value) {
    return '无轨迹数据'
  }

  try {
    // 尝试将message解析为JSON对象
    const jsonData = typeof flightDetailData.value === 'string'
      ? JSON.parse(flightDetailData.value)
      : flightDetailData.value

    // 格式化JSON，使用2个空格缩进
    return JSON.stringify(jsonData, null, 1)
      .replace(/ {1}/g, '\t') // 替换为制表符，使格式更清晰
  } catch (e) {
    // 如果不是JSON格式，直接显示原始内容
    return `非JSON格式数据：\n${flightDetailData.value}`
  }
})

const imageEntities = ref<Cesium.Entity[]>([])
const previewModalVisible = ref(false)
const previewImageUrl = ref('')
const isClickHandlerAdded = ref(false)
const currentPopupEntity = ref<Cesium.Entity | null>(null)
const directionArrows = ref<Cesium.Entity[]>([])

// 轨迹播放
const playbackPositions = ref<Cesium.Cartesian3[]>([]) // 存储所有轨迹点位置
const aircraftEntity = ref<Cesium.Entity | null>(null) // 飞机模型实体
let playbackAnimFrameId: number | null = null // requestAnimationFrame ID
let currentPlaybackIndex = 0 // 当前播放到的线段起点索引
const currentInterpolationProgress = ref(0) // 当前线段内的插值进度 [0, 1]
let lastFrameTime = 0 // 上一帧的时间戳
const isPlaying = ref(false) // 是否正在播放
const playbackSpeed = ref(1) // 播放速度倍数
const hasTrajectory = ref(false)
const playbackHeadings = ref<number[]>([])
const BASE_MOVE_SPEED = 60 // 基础移动速度（米/秒），可根据轨迹点密度调整
let dynamicPositions: Cesium.Cartesian3[] = [] // 存储实时画线的位置数据
const dynamicTrajectoryEntity = ref<Cesium.Entity | null>(null) // 实时画的轨迹线实体

const getTrajectory = async (record) => {
  const res = await taskTrajectory(record.job_id)
  if (res && res.code === 0) {
    flightDetailData.value = res.data

    // 初始化 Cesium 视图和点击事件
    if (!viewer.value) {
      const mapView = useDefaultCesium(mapRef.value)
      viewer.value = mapView.viewer
      if (!isClickHandlerAdded.value) {
        const handler = new Cesium.ScreenSpaceEventHandler(viewer.value.scene.canvas)
        handler.setInputAction((click: any) => {
          const picked = viewer.value!.scene.pick(click.position)
          if (picked && picked.id) {
            handleEntityClick(picked.id)
          }
        }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
        isClickHandlerAdded.value = true
      }
    }

    setTimeout(() => {
      if (!res.data || res.data.length === 0) {
        message.error('暂无轨迹数据')
        return
      }

      // 清除旧的实体
      if (polylineEntity.value) {
        viewer.value.entities.remove(polylineEntity.value)
      }
      if (pointArrEntity.value && pointArrEntity.value.length > 0) {
        pointArrEntity.value.forEach(entity => {
          viewer.value.entities.remove(entity)
        })
        pointArrEntity.value = []
      }

      const list = [] as Cesium.Cartesian3[]

      // 构建位置数组
      res.data.forEach((item) => {
        const position = Cesium.Cartesian3.fromDegrees(
          Number(item.lon),
          Number(item.lat),
          Number(item.height)
        )
        list.push(position)
      })

      // 创建折线实体
      polylineEntity.value = viewer.value.entities.add({
        polyline: {
          positions: list,
          width: 6,
          material: new Cesium.PolylineOutlineMaterialProperty({
            color: Cesium.Color.fromCssColorString('#2d8cf0'),
            outlineColor: new Cesium.Color(1, 1, 1, 1),
            outlineWidth: 3
          }),
          clampToGround: false,
          arcType: Cesium.ArcType.GEODESIC
        }
      })

      // 创建点实体
      res.data.forEach((item, index) => {
        const position = Cesium.Cartesian3.fromDegrees(
          Number(item.lon),
          Number(item.lat),
          Number(item.height)
        )
        const editPoint = addPoint(position, index) as Cesium.Entity
        pointArrEntity.value.push(editPoint)
      })

      // 调整视角到轨迹范围
      const boundingSphere = Cesium.BoundingSphere.fromPoints(list)
      viewer.value.camera.flyToBoundingSphere(boundingSphere, {
        duration: 0,
        offset: new Cesium.HeadingPitchRange(0, -0.5, boundingSphere.radius * 2.5)
      })

      // ========== 新增：准备轨迹播放数据 ==========
      playbackPositions.value = []
      playbackHeadings.value = []
      if (res.data && res.data.length) {
        // 构建位置数组
        for (let i = 0; i < res.data.length; i++) {
          const item = res.data[i]
          const position = Cesium.Cartesian3.fromDegrees(
            Number(item.lon),
            Number(item.lat),
            Number(item.height)
          )
          playbackPositions.value.push(position)
        }
        // 计算每个线段的方向（弧度，正北顺时针）
        for (let i = 0; i < playbackPositions.value.length - 1; i++) {
          const heading = getBearingRadians(playbackPositions.value[i], playbackPositions.value[i + 1])
          playbackHeadings.value.push(heading)
        }
        // 最后一点的方向与上一段相同（播放时不会用到）
        if (playbackPositions.value.length > 0) {
          playbackHeadings.value.push(playbackHeadings.value[playbackHeadings.value.length - 1] || 0)
        }
        hasTrajectory.value = playbackPositions.value.length > 1
        // 创建飞机实体（如果还没有）
        createAircraftEntity()
      } else {
        hasTrajectory.value = false
      }
      // ========== 结束新增 ==========
    }, 5000) // 延时确保地图容器已加载

    // 加载图片点位（全景照片）
    try {
      const imageRes = await getImageJobShowTrack(record.job_id)
      if (imageRes && imageRes.code === 0 && Array.isArray(imageRes.data)) {
        // 清除旧的图片实体
        imageEntities.value.forEach(entity => viewer.value?.entities.remove(entity))
        imageEntities.value = []

        // 遍历图片数据，添加 billboard
        imageRes.data.forEach((item: any) => {
          const lon = Number(item.gpsLongitude)
          const lat = Number(item.gpsLatitude)
          const height = Number(item.absoluteAltitude) || 0
          const position = Cesium.Cartesian3.fromDegrees(lon, lat, height)

          const entity = viewer.value.entities.add({
            position: position,
            billboard: {
              image: PanoramicPhotos,
              width: 32,
              height: 32,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              heightReference: Cesium.HeightReference.NONE,
              disableDepthTestDistance: Number.POSITIVE_INFINITY
            },
            imageUrl: item.url,
            abbreviationUrl: item.abbreviationUrl,
            gimbalYaw: item.gimbalYawDegree,
            gimbalPitch: item.gimbalPitchDegree,
            absoluteAltitude: item.absoluteAltitude
          })
          imageEntities.value.push(entity)
        })
      } else {
        console.log('没有图片数据或接口返回异常')
      }
    } catch (error) {
      console.error('获取图片点位失败:', error)
    }
  }
}

const handleEntityClick = (entity: Cesium.Entity) => {
  if (!entity) return
  if (entity.isPopupImage) {
    previewImageUrl.value = entity.imageUrl
    previewModalVisible.value = true
    if (currentPopupEntity.value) {
      viewer.value?.entities.remove(currentPopupEntity.value)
      currentPopupEntity.value = null
    }
    return
  }

  if (entity.imageUrl) {
  // 清除之前的箭头和弹窗
    if (directionArrows.value.length) {
      directionArrows.value.forEach(arrow => viewer.value?.entities.remove(arrow))
      directionArrows.value = []
    }
    if (currentPopupEntity.value) {
      viewer.value?.entities.remove(currentPopupEntity.value)
      currentPopupEntity.value = null
    }

    // 加载并缩放图片
    const img = new Image()
    img.crossOrigin = 'Anonymous' // 如果图片跨域需要
    img.src = entity.abbreviationUrl
    img.onload = () => {
      let width = img.width
      let height = img.height
      const maxWidth = 200
      const maxHeight = 150
      // 如果图片尺寸超过限制，按比例缩放
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height)
        width = Math.floor(width * ratio)
        height = Math.floor(height * ratio)
      }
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, width, height)

      const popupEntity = viewer.value!.entities.add({
        position: entity.position,
        billboard: {
          image: canvas, // 使用缩放后的 canvas
          width: width,
          height: height,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(0, -50),
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          color: Cesium.Color.WHITE,
        },
        isPopupImage: true,
        imageUrl: entity.imageUrl,
        parentEntity: entity
      })
      currentPopupEntity.value = popupEntity
    }
    img.onerror = () => {
      console.warn('图片加载失败，使用默认图标')
      // 可添加一个默认图标作为后备
      const defaultEntity = viewer.value!.entities.add({
        position: entity.position,
        billboard: {
          image: 'path/to/default-icon.png',
          width: 32,
          height: 32,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(0, -50),
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
        },
        isPopupImage: true,
        imageUrl: entity.imageUrl,
        parentEntity: entity
      })
      currentPopupEntity.value = defaultEntity
    }

    // 添加方向箭头（原有逻辑不变）
    if (entity.gimbalYaw !== undefined && entity.gimbalPitch !== undefined) {
      addDirectionArrow(entity.position.getValue(Cesium.JulianDate.now()), entity.gimbalYaw, entity.gimbalPitch, entity.absoluteAltitude)
    }
  }
}

const addDirectionArrow = (position: Cesium.Cartesian3, yaw: number, pitch: number, length: number) => {
  const direction = Cesium.Cartesian3.fromSpherical({
    clock: Cesium.Math.toRadians(yaw),
    cone: Cesium.Math.toRadians(90 - pitch),
    magnitude: length
  })

  // 终点 = 起点 + 方向
  const endPoint = Cesium.Cartesian3.add(position, direction, new Cesium.Cartesian3())

  // 创建箭头
  const arrowEntity = viewer.value.entities.add({
    polyline: {
      positions: [endPoint, position],
      width: 5,
      material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.RED),
      arcType: Cesium.ArcType.NONE
    }
  })

  const endPointEntity = viewer.value.entities.add({
    position: endPoint,
    point: { pixelSize: 10, color: Cesium.Color.RED }
  })

  directionArrows.value.push(arrowEntity, endPointEntity)
}

function addPoint (position, index:number) {
  const entity = viewer.value?.entities.add({
    position: position,
    point: {
      pixelSize: 8,
      color: new Cesium.Color(1, 1, 1, 0.7),
      disableDepthTestDistance: 3000000,
      show: true
    },
    billboard: {
      image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYAQMAAADJbu9PAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFAAAAW/tlDx7VPwAAAAJ0Uk5TAP9bkSK1AAAAJElEQVR4nGNkrGdk3svIfpOR/yGj/E1G+72M9fWM/xlAgqQgALk7Exo5KkuiAAAAAElFTkSuQmCC',
      show: false,
      scale: 0.35,
      disableDepthTestDistance: 3000000
    }
  })
  entity.pointIndex = index + 1
  entity.typeInfo = 'editPoint'
  entity.parent = polylineEntity.value
  return entity
}

function getBearingRadians (from: Cesium.Cartesian3, to: Cesium.Cartesian3): number {
  const cartographicFrom = Cesium.Cartographic.fromCartesian(from)
  const cartographicTo = Cesium.Cartographic.fromCartesian(to)
  const lon1 = cartographicFrom.longitude
  const lat1 = cartographicFrom.latitude
  const lon2 = cartographicTo.longitude
  const lat2 = cartographicTo.latitude

  const deltaLon = lon2 - lon1
  const x = Math.sin(deltaLon) * Math.cos(lat2)
  const y = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLon)
  let bearing = Math.atan2(x, y) // 弧度，从北顺时针
  if (bearing < 0) bearing += 2 * Math.PI
  return bearing
}

const createAircraftEntity = () => {
  if (aircraftEntity.value) {
    viewer.value?.entities.remove(aircraftEntity.value)
  }
  if (!viewer.value || playbackPositions.value.length === 0) return

  aircraftEntity.value = viewer.value.entities.add({
    position: playbackPositions.value[0],
    billboard: {
      image: dronePhotos,
      width: 40,
      height: 40,
      verticalOrigin: Cesium.VerticalOrigin.CENTER, // 改为 CENTER，旋转更自然
      horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      disableDepthTestDistance: Number.POSITIVE_INFINITY,
      // 关键：让 rotation 在地球表面上按地理方向旋转，而不是屏幕方向
      alignedAxis: Cesium.Cartesian3.UNIT_Z,
      rotation: 0
    }
  })
}

const startPlayback = () => {
  if (!hasTrajectory.value || playbackPositions.value.length < 2) return
  if (isPlaying.value) return

  // 播放时隐藏全景照片图标，避免视觉干扰
  imageEntities.value.forEach(entity => {
    if (entity.billboard) entity.billboard.show = false
  })

  // 隐藏原有的轨迹线和轨迹点
  if (polylineEntity.value) polylineEntity.value.show = false
  // if (pointArrEntity.value) pointArrEntity.value.forEach(p => p.show = false)
  if (pointArrEntity.value) pointArrEntity.value.forEach(p => { p.show = false })

  // 初始化并创建动态轨迹线
  dynamicPositions = [playbackPositions.value[0]]
  if (dynamicTrajectoryEntity.value) {
    viewer.value?.entities.remove(dynamicTrajectoryEntity.value)
  }
  dynamicTrajectoryEntity.value = viewer.value?.entities.add({
    polyline: {
      // 使用 CallbackProperty 实时更新线的位置
      positions: new Cesium.CallbackProperty(() => dynamicPositions, false),
      width: 6,
      material: new Cesium.PolylineOutlineMaterialProperty({
        color: Cesium.Color.fromCssColorString('#2d8cf0'),
        outlineColor: new Cesium.Color(1, 1, 1, 1),
        outlineWidth: 3
      }),
      clampToGround: false,
      arcType: Cesium.ArcType.GEODESIC
    }
  })

  // 如果已播放到末尾，先重置
  if (currentPlaybackIndex >= playbackPositions.value.length - 1) {
    currentPlaybackIndex = 0
    currentInterpolationProgress.value = 0
  }

  isPlaying.value = true
  lastFrameTime = performance.now()

  const animate = (currentTime: number) => {
    if (!isPlaying.value) return

    // 计算帧间隔（秒），限制最大值防止切换标签页回来后大幅跳帧
    const deltaTime = Math.min((currentTime - lastFrameTime) / 1000, 0.1)
    lastFrameTime = currentTime

    // 已到达终点
    if (currentPlaybackIndex >= playbackPositions.value.length - 1) {
      if (aircraftEntity.value) {
        aircraftEntity.value.position = playbackPositions.value[playbackPositions.value.length - 1]
        const lastHeading = playbackHeadings.value[playbackPositions.value.length - 1] || 0
        aircraftEntity.value.billboard.rotation = lastHeading
      }
      isPlaying.value = false
      playbackAnimFrameId = null
      return
    }

    // 当前线段的起点和终点
    const fromPos = playbackPositions.value[currentPlaybackIndex]
    const toPos = playbackPositions.value[currentPlaybackIndex + 1]
    let segmentDistance = Cesium.Cartesian3.distance(fromPos, toPos)

    // 本帧应该前进的距离（米）
    const moveDistance = BASE_MOVE_SPEED * playbackSpeed.value * deltaTime

    // 更新插值进度
    if (segmentDistance > 0) {
      currentInterpolationProgress.value += moveDistance / segmentDistance
    } else {
      // 两点重合，直接跳到下一个点
      currentInterpolationProgress.value = 1
    }

    // 如果进度超过 1，说明本帧跨越了多个线段，逐段推进
    if (currentInterpolationProgress.value >= 1 && currentPlaybackIndex < playbackPositions.value.length - 1) {
      currentInterpolationProgress.value -= 1
      currentPlaybackIndex++

      if (currentPlaybackIndex >= playbackPositions.value.length - 1) {
        // 到达终点
        if (aircraftEntity.value) {
          aircraftEntity.value.position = playbackPositions.value[playbackPositions.value.length - 1]
          const lastHeading = playbackHeadings.value[playbackPositions.value.length - 1] || 0
          aircraftEntity.value.billboard.rotation = lastHeading
        }
        isPlaying.value = false
        playbackAnimFrameId = null
        return
      }

      // 重新计算新线段的距离，将剩余进度转换到新线段
      const newFromPos = playbackPositions.value[currentPlaybackIndex]
      const newToPos = playbackPositions.value[currentPlaybackIndex + 1]
      const newSegmentDistance = Cesium.Cartesian3.distance(newFromPos, newToPos)

      if (newSegmentDistance > 0 && currentInterpolationProgress.value > 0) {
        // 将上一段剩余的插值进度换算为新段的实际距离，再除以新段长度
        const remainingDistance = currentInterpolationProgress.value * segmentDistance
        currentInterpolationProgress.value = remainingDistance / newSegmentDistance
      }
      // 更新 segmentDistance 供后续插值计算使用
      segmentDistance = newSegmentDistance
    }

    // 最终确保不越界
    if (currentPlaybackIndex >= playbackPositions.value.length - 1) {
      isPlaying.value = false
      playbackAnimFrameId = null
      return
    }

    // 线性插值计算当前位置
    const finalFrom = playbackPositions.value[currentPlaybackIndex]
    const finalTo = playbackPositions.value[currentPlaybackIndex + 1]
    const t = Math.min(Math.max(currentInterpolationProgress.value, 0), 1)
    const currentPosition = Cesium.Cartesian3.lerp(finalFrom, finalTo, t, new Cesium.Cartesian3())

    if (aircraftEntity.value) {
      aircraftEntity.value.position = currentPosition

      // 方向：使用当前线段的航向角
      const heading = playbackHeadings.value[currentPlaybackIndex] || 0
      aircraftEntity.value.billboard.rotation = -heading
    }

    // 【新增】将当前实时位置推入动态轨迹数组，线会自动跟着变长
    dynamicPositions.push(currentPosition)

    playbackAnimFrameId = requestAnimationFrame(animate)
  }

  playbackAnimFrameId = requestAnimationFrame(animate)
}

const pausePlayback = () => {
  if (playbackAnimFrameId !== null) {
    cancelAnimationFrame(playbackAnimFrameId)
    playbackAnimFrameId = null
  }
  isPlaying.value = false

  // 恢复显示全景照片图标
  imageEntities.value.forEach(entity => {
    if (entity.billboard) entity.billboard.show = true
  })
}

const resetPlayback = () => {
  pausePlayback()
  currentPlaybackIndex = 0
  currentInterpolationProgress.value = 0

  if (aircraftEntity.value && playbackPositions.value.length) {
    aircraftEntity.value.position = playbackPositions.value[0]
    aircraftEntity.value.billboard.rotation = 0
  }

  // 恢复原有轨迹线和轨迹点显示
  if (polylineEntity.value) polylineEntity.value.show = true
  // if (pointArrEntity.value) pointArrEntity.value.forEach(p => p.show = true)
  if (pointArrEntity.value) pointArrEntity.value.forEach(p => { p.show = true })

  // 移除动态轨迹线
  if (dynamicTrajectoryEntity.value) {
    viewer.value?.entities.remove(dynamicTrajectoryEntity.value)
    dynamicTrajectoryEntity.value = null
  }
  dynamicPositions = []

  // 确保恢复显示照片
  imageEntities.value.forEach(entity => {
    if (entity.billboard) entity.billboard.show = true
  })
}

// 调整播放速度
const adjustSpeed = () => {
  // 速度变更在下一帧自动生效，无需额外处理
  // 如果之前是暂停状态想继续播放，可以取消下面注释
  if (!isPlaying.value && hasTrajectory.value) {
    startPlayback()
  }
}

const handleCancel = () => {
  // 停止播放（内部已使用 cancelAnimationFrame）
  pausePlayback()

  // 清除 Cesium 实体
  if (polylineEntity.value) {
    viewer.value?.entities.remove(polylineEntity.value!)
    polylineEntity.value = null
    pointArrEntity.value?.forEach(item => {
      viewer.value?.entities.remove(item)
    })
    pointArrEntity.value = []
  }

  // 清除动态轨迹线
  if (dynamicTrajectoryEntity.value) {
    viewer.value?.entities.remove(dynamicTrajectoryEntity.value)
    dynamicTrajectoryEntity.value = null
  }
  dynamicPositions = []

  if (imageEntities.value.length) {
    imageEntities.value.forEach(entity => viewer.value?.entities.remove(entity))
    imageEntities.value = []
  }
  if (currentPopupEntity.value) {
    viewer.value?.entities.remove(currentPopupEntity.value)
    currentPopupEntity.value = null
  }
  if (directionArrows.value.length) {
    directionArrows.value.forEach(arrow => viewer.value?.entities.remove(arrow))
    directionArrows.value = []
  }
  if (aircraftEntity.value) {
    viewer.value?.entities.remove(aircraftEntity.value)
    aircraftEntity.value = null
  }

  // 重置播放状态
  currentPlaybackIndex = 0
  currentInterpolationProgress.value = 0

  // 确保关闭模态框时照片恢复可见
  imageEntities.value.forEach(entity => {
    if (entity.billboard) entity.billboard.show = true
  })
  modalVisible.value = false
}

onUnmounted(() => {
  // 停止动画帧
  if (playbackAnimFrameId !== null) {
    cancelAnimationFrame(playbackAnimFrameId)
    playbackAnimFrameId = null
  }

  // 清除动态轨迹线
  if (dynamicTrajectoryEntity.value) {
    viewer.value?.entities.remove(dynamicTrajectoryEntity.value)
    dynamicTrajectoryEntity.value = null
  }
  dynamicPositions = []

  if (viewer.value) {
    viewer.value.destroy()
    viewer.value = null
  }
  if (drawTool.value) {
    drawTool.value.destroy()
    drawTool.value = null
  }
  if (imageEntities.value.length) {
    imageEntities.value.forEach(entity => viewer.value?.entities.remove(entity))
    imageEntities.value = []
  }
  if (currentPopupEntity.value) {
    viewer.value?.entities.remove(currentPopupEntity.value)
    currentPopupEntity.value = null
  }
})

const hasAnyAction = (record: any) => {
  // 根据你的实际状态枚举值调整判断条件
  return record.status === TaskStatus.Wait ||
         record.status === TaskStatus.Carrying ||
         record.status === TaskStatus.Paused ||
         record.status === TaskStatus.Success ||
         (record.status === TaskStatus.Success && record.alarm_count > 0)
}

const reportVisible = ref(false)

const reportTags = ref('')
const selectTags = ref([])

const selectedCategoryValue = ref<string | null>(null)
const reportTreeData = ref<any[]>([]) // 树形数据
const selectedKeys = ref<string[]>([]) // 选中的节点 key（数组，单选）

const specialTopicList = ref<TreeSelectNode[]>([])

const selectedTopicValue = ref<string | null>(null)
const selectedTopicNode = ref<TreeSelectNode | null>(null)

const defaultTopicName = ref('')
const defaultTopicType = ref('')

const findNodeByValue = (nodes: TreeSelectNode[], value: number): TreeSelectNode | null => {
  for (const node of nodes) {
    if (node.value === value) return node
    if (node.children) {
      const found = findNodeByValue(node.children, value)
      if (found) return found
    }
  }
  return null
}

const findNodeByNameAndType = (nodes: TreeSelectNode[], name: string, type: string): TreeSelectNode | null => {
  for (const node of nodes) {
    if (node.title === name && node.rawData?.type === type) {
      return node
    }
    if (node.children && node.children.length) {
      const found = findNodeByNameAndType(node.children, name, type)
      if (found) return found
    }
  }
  return null
}

const handleTopicChange = (value: number | null) => {
  if (value === null) {
    selectedTopicNode.value = null
    return
  }
  const node = findNodeByValue(specialTopicList.value, value)
  if (node && node.isLeaf && !node.disabled) { // 增加 disabled 判断
    selectedTopicNode.value = node
  } else {
    message.warning('请选择有效的专题应用（最后一层且包含应用编码）')
    selectedTopicValue.value = null
    selectedTopicNode.value = null
  }
}

const convertToTreeSelectNodes = (nodes: SpecialTreeNode[]): TreeSelectNode[] => {
  if (!nodes || nodes.length === 0) return []

  return nodes.map((node) => {
    const treeNode: TreeSelectNode = {
      key: node.id,
      title: node.name,
      value: node.id,
      rawData: node,
      isLeaf: !node.children || node.children.length === 0
    }
    if (node.children && node.children.length > 0) {
      treeNode.children = convertToTreeSelectNodes(node.children)
    }
    return treeNode
  })
}

const loadSpecialListTree = async () => {
  try {
    const treeRes = await getAllSpecialTree()
    const rawTreeData: SpecialTreeNode[] = treeRes.data || []
    console.log('treeRes.data', treeRes.data)
    const thirdRes = await getAllSpecialData()
    const thirdNodes: SpecialThirdNode[] = thirdRes.data || []
    console.log('thirdRes.data', thirdRes.data)

    const childrenMap = new Map<string, SpecialThirdNode[]>()
    thirdNodes.forEach(node => {
      const category = node.category
      if (!childrenMap.has(category)) {
        childrenMap.set(category, [])
      }
      childrenMap.get(category)!.push(node)
    })

    const buildTreeNodes = (nodes: SpecialTreeNode[]): TreeSelectNode[] => {
      return nodes.map(node => {
        const hasChildren = node.children && node.children.length > 0
        let childrenNodes: TreeSelectNode[] = []
        if (hasChildren) {
          // 递归处理第二层（可能有更深层，但业务上仅三层）
          childrenNodes = buildTreeNodes(node.children!)
        } else {
          // 第二层节点：挂载第三层数据
          const matchedThird = childrenMap.get(node.code) || []
          childrenNodes = matchedThird.map(third => ({
            key: third.appCode,
            title: third.appName,
            value: third.appCode,
            appCode: third.appCode,
            isLeaf: true,
            disabled: !third.appCode, // 有 appCode 才可选
            rawData: third
          }))
        }
        // 第一层、第二层节点均不可选
        return {
          key: node.code,
          title: node.name,
          value: node.code,
          disabled: true, // 强制禁用所有原始树节点
          children: childrenNodes,
          rawData: node
        }
      })
    }

    specialTopicList.value = buildTreeNodes(rawTreeData)
  } catch (error) {
    console.error('加载专题树失败:', error)
    message.error('加载专题树失败')
  }
}

/* const getReportTypeData = async () => {
  const param = {
    status: 1
  }
  const res = await getTemplatesTree(param)
  reportTags.value = res.data
  selectTags.value = reportTags.value.map(() => false)
} */

const getReportTypeData = async () => {
  try {
    const res = await getTemplatesListTree('single-report')
    if (res && res.code === 0) {
      reportTreeData.value = res.data || []
    }
  } catch (error) {
    console.error('获取报告分类树失败', error)
  }
}

const onTreeSelectChange = (value: string | null) => {
  if (!value) {
    // 清空选中
    filterParams.value.template_category_code = ''
    selectedCategoryValue.value = null
    selectedKeys.value = []
  } else {
    // 根据 value（categoryId）查找对应节点的 categoryCode
    const findNodeByKey = (nodes: any[], key: string): any => {
      for (const node of nodes) {
        if (node.categoryId === key) return node
        if (node.children && node.children.length) {
          const found = findNodeByKey(node.children, key)
          if (found) return found
        }
      }
      return null
    }
    const selectedNode = findNodeByKey(reportTreeData.value, value)
    if (selectedNode && selectedNode.categoryCode) {
      filterParams.value.template_category_code = selectedNode.categoryCode
      selectedCategoryValue.value = value
      // 如果需要同步 selectedKeys（用于其他地方，可保留）
      selectedKeys.value = [value]
    } else {
      filterParams.value.template_category_code = ''
      selectedCategoryValue.value = null
      message.warning('该分类无有效编码')
    }
  }
  // 刷新模板列表
  getTemplateData()
}

const handleChange = (tag, checked) => {
  if (checked) {
    selectTags.value = selectTags.value.map(() => false)
    const currentIndex = reportTags.value.findIndex(item => item.categoryId === tag.categoryId)
    selectTags.value[currentIndex] = true
    filterParams.value.template_category_id = tag.categoryId
  } else {
    filterParams.value.template_category_id = ''
  }
  getTemplateData()
}

const filterParams = ref({
  status: 0,
  template_category_code: ''
})
const jobIdValue = ref('')

function openReport (record: any) {
  reportVisible.value = true

  selectedTemplateCode.value = ''
  previewHtml.value = ''
  previewLoading.value = false
  generateLoading.value = false

  jobIdValue.value = record.job_id
  reportName.value = record.job_name
  reportVersion.value = ''
  inspectionTarget.value = record.workspace_name
  executiveAirport.value = record.dock_name
  specializedApplication.value = record.portion

  defaultTopicName.value = record.portion || ''
  defaultTopicType.value = record.portion_type || ''

  getTemplateData()
  getReportTypeData()

  loadSpecialListTree().then(() => {
    if (defaultTopicName.value && defaultTopicType.value) {
      const targetNode = findNodeByNameAndType(specialTopicList.value, defaultTopicName.value, defaultTopicType.value)
      if (targetNode && !targetNode.disabled && targetNode.appCode) {
        selectedTopicValue.value = targetNode.value
        selectedTopicNode.value = targetNode
      } else {
        // 若节点无效，清空选择并提示
        selectedTopicValue.value = null
        selectedTopicNode.value = null
        message.warning(`专题“${defaultTopicName.value}”无效（缺少应用编码），请重新选择`)
      }
    }
  })
}

const selectedTemplateCode = ref('')
const modelList = ref('')
const reportName = ref('')
const reportVersion = ref('')
const inspectionTarget = ref('')
const executiveAirport = ref('')
const specializedApplication = ref('')
const reportingMethod = ref('1')
const generativeForm = ref('1')
const previewHtml = ref('')
const previewLoading = ref(false)
const generateLoading = ref(false)

const getTemplateData = async () => {
  const params = {
    status: filterParams.value.status,
    template_category_code: filterParams.value.template_category_code // 使用 code
  }
  const res = await getTemplatesList(params)
  modelList.value = res.data
  console.log('modelList.value', modelList.value)
}

function selectTemplate (item: any) {
  selectedTemplateCode.value = item.template_code
}

const handlePreview = async () => {
  if (!selectedTemplateCode.value) {
    message.warning('请选择模板')
    return
  }
  if (!reportName.value.trim()) {
    message.warning('请输入报告名称')
    return
  }
  if (!jobIdValue.value) {
    message.warning('任务ID不存在')
    return
  }

  try {
    previewLoading.value = true
    const params = {
      template_code: selectedTemplateCode.value,
      sql_params: { jobId: jobIdValue.value },
      file_name: reportName.value.trim()
    }
    const res = await getGenerateHTML(params)
    previewHtml.value = res.data || '<div style="text-align:center;padding:20px;">暂无预览内容</div>'
  } catch (error) {
    // console.error('生成报告预览失败：', error)
    previewHtml.value = '<div style="text-align:center;padding:20px;color:#f5222d;">预览生成失败，请重试</div>'
  } finally {
    previewLoading.value = false
  }
}

const handleGeneratePDF = async () => {
  if (!selectedTemplateCode.value) {
    message.warning('请先选择报告模板')
    return
  }
  if (!reportName.value.trim()) {
    message.warning('请输入报告名称')
    return
  }
  if (!reportVersion.value) {
    message.warning('请输入报告版本号')
    return
  }
  if (!jobIdValue.value) {
    message.warning('任务ID不存在，无法生成PDF')
    return
  }

  try {
    generateLoading.value = true

    let specialAppCode = ''
    let topicType = ''
    if (selectedTopicNode.value && selectedTopicNode.value.isLeaf) {
      specialAppCode = selectedTopicNode.value.title // appName
      console.log('selectedTopicNode.value.title', selectedTopicNode.value.title)
      topicType = selectedTopicNode.value.rawData?.type || '' // type
    }

    const requestParams = {
      template_code: selectedTemplateCode.value,
      sql_params: { jobId: jobIdValue.value },
      file_name: reportName.value.trim(),
      version: reportVersion.value,
      specialAppCode: specialAppCode,
      type: topicType
    }
    const res = await getExportPDFReport(requestParams)
    if (res) {
      message.success('PDF报告生成中')
      reportVisible.value = false
    }
  } catch (error) {
    console.error('导出PDF报告失败：', error)
    if (error instanceof Error) {
      message.error(`PDF生成失败：${error.message}`)
    } else {
      message.error('PDF报告生成失败，请重试')
    }
  } finally {
    generateLoading.value = false
  }
}

// 专门的下载函数
const downloadBlobAsPDF = (blob: Blob, fileName: string) => {
  // 创建对象URL
  const url = window.URL.createObjectURL(blob)

  // 创建下载链接
  const link = document.createElement('a')
  link.href = url
  link.download = `${fileName.replace(/[\\/:*?"<>|]/g, '_')}.pdf`
  link.style.display = 'none'

  // 添加到文档并触发下载
  document.body.appendChild(link)
  link.click()

  // 清理
  setTimeout(() => {
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }, 100)

  message.success('PDF报告生成成功，已开始下载')
}

const uploadReportVisible = ref(false)
const waylineList = ref('')
const uploadProgress = ref(0)

const uploadReportRef = ref()
const selectedRowKeys = ref<string[]>([])
const selectedRows = ref<any[]>([])
const reportChoseVisible = ref(false)
// 存储上一次的选择（用于记录以便操作）
const lastSelectedRows = ref<any[]>([])
const lastSelectedRowKeys = ref<string[]>([])
const choseData = ref([])
const workspaceList = ref('')
const templateList = ref([])
const taskNameValue = ref('')
const workspaceNameValue = ref(null)
const dockNameValue = ref(null)
const reportNameValue = ref('')
const reportDataTime = ref([])

const uploadReportState = reactive({
  name: '',
  version: '',
  type: undefined,
  time: 'single',
  wayline: undefined,
  waylineName: '',
  file: null,
  fileList: [],
  objectKey: ''
})

const uploadReportRules = {
  name: [{ required: true, message: '请输入报告名称', trigger: 'blur' }],
  version: [{ required: true, message: '请输入报告版本号', trigger: 'blur' }],
  wayline: [{ required: true, message: '请选择关联任务', trigger: ['blur', 'change'] }],
  type: [{ required: true, message: '请选择报告类型', trigger: 'change' }],
  file: [{
    required: true,
    validator: async (_rule: any, value: any) => {
      if (!uploadReportState.file && !uploadReportState.objectKey) {
        throw new Error('请上传报告文件')
      }
    },
    trigger: 'change'
  }]
}

const choseColumns = computed(() => {
  if (uploadReportState.time === 'single') {
    return [
      { title: '任务名称', dataIndex: 'name', ellipsis: true, align: 'center' },
      { title: '主体名称', dataIndex: 'portion', key: 'portion', align: 'center' },
      { title: '机场', dataIndex: 'dockName', align: 'center' },
      { title: '执行时间', dataIndex: 'executeTime', key: 'duration', align: 'center' }
    ]
  } else {
    return [
      { title: '报告名称', dataIndex: 'name', ellipsis: true, align: 'center' },
      { title: '报告周期', dataIndex: 'period_type', align: 'center', customRender: ({ text }) => periodTypeStatus[text] || text },
      { title: '上传时间', dataIndex: 'create_time', align: 'center' }
    ]
  }
})

const periodTypeStatus = {
  single: '单次报告',
  daily: '日报',
  weekly: '周报',
  monthly: '月报',
  quarterly: '季报',
  yearly: '年报'
}

const rowSelection = computed(() => {
  const isSingle = uploadReportState.time === 'single'

  return {
    type: isSingle ? 'radio' : 'checkbox', // 单次为单选，周期为多选
    selectedRowKeys: selectedRowKeys.value,
    onChange: (selectedKeys: string[], selectedRowsData: any[]) => {
      selectedRowKeys.value = selectedKeys
      selectedRows.value = selectedRowsData
    },
    onSelect: (record: any, selected: boolean, selectedRowsData: any[]) => {
      selectedRows.value = selectedRowsData
    },
    onSelectAll: (selected: boolean, selectedRowsData: any[], changeRows: any[]) => {
      selectedRows.value = selectedRowsData
    }
  }
})

const reportSelect = () => {
  if (!uploadReportState.time) {
    return message.error('请选择报告周期')
  } else {
    reportChoseVisible.value = true
    getWorkspaceLists()

    // 设置默认选中项（如果有上一次选择记录）
    if (lastSelectedRowKeys.value.length > 0) {
      selectedRowKeys.value = [...lastSelectedRowKeys.value]
      // 尝试从当前数据中查找对应的行
      if (choseData.value.length > 0) {
        selectedRows.value = choseData.value.filter(item =>
          selectedRowKeys.value.includes(item.id)
        )
      }
    } else {
      selectedRowKeys.value = []
      selectedRows.value = []
    }

    if (uploadReportState.time === 'single') {
      // 在显示模态框时检查是否需要获取机场列表
      if (workspaceNameValue.value) {
        getDockSN().then(() => {
          fetchPlanData(false)
        })
      } else {
        fetchPlanData(false)
      }
    } else {
      fetchChoseReportData(false)
    }
  }
}

const choseReportPagination = reactive({
  pageSizeOptions: ['10', '20', '50', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
  pageSize: 10,
  current: 1,
  total: 0,
  showTotal: (total: number) => `总计 ${total} 条`
})

const choseSubmit = () => {
  // 首先检查 selectedRows，如果没有数据，再检查 selectedRowKeys
  if (selectedRows.value.length === 0 && selectedRowKeys.value.length === 0) {
    message.error('请选择至少一条记录')
    return
  }

  // 如果 selectedRows 为空但 selectedRowKeys 有值，尝试从 choseData 中查找对应的行
  if (selectedRows.value.length === 0 && selectedRowKeys.value.length > 0) {
    selectedRows.value = choseData.value.filter(item =>
      selectedRowKeys.value.includes(item.id)
    )
  }

  // 再次检查
  if (selectedRows.value.length === 0) {
    message.error('请选择至少一条记录')
    return
  }

  // 记录本次选择
  lastSelectedRows.value = [...selectedRows.value]
  lastSelectedRowKeys.value = [...selectedRowKeys.value]

  // 根据报告周期类型设置不同的ID和名称
  if (uploadReportState.time === 'single') {
    // 单次报告：单选，使用job_id和name
    const selectedRow = selectedRows.value[0]
    uploadReportState.wayline = selectedRow.jobId
    uploadReportState.waylineName = selectedRow.name
  } else {
    // 周期报告：多选，使用report_id和name，用逗号分隔
    const ids = selectedRows.value.map(row => row.id).join(',')
    const names = selectedRows.value.map(row => row.name).join(', ')
    uploadReportState.wayline = ids
    uploadReportState.waylineName = names
  }

  reportChoseVisible.value = false
  message.success('选择成功')
  nextTick(() => {
    uploadReportRef.value?.validateFields('wayline').catch(() => {})
  })
}

// 选择取消
const choseCancel = () => {
  reportChoseVisible.value = false
  choseReportPagination.current = 1
}

const handleWorkspaceChange = async () => {
  dockNameValue.value = null
  await getDockSN()
}

const refreshPlanData = async () => {
  taskNameValue.value = ''
  workspaceNameValue.value = null
  dockNameValue.value = null
  dockSnList.value = ''
  fetchPlanData(true)
}

const refreshChoseReport = () => {
  reportNameValue.value = ''
  reportDataTime.value = []
  fetchChoseReportData(true)
}

const getWorkspaceLists = async () => {
  const res = await getWorkSpaceList()
  workspaceList.value = res.data
}

const getTemplateList = async () => {
  const res = await getTemplatesList({ status: 0, template_category_code: 'week-report' })
  templateList.value = res.data
}

const fetchPlanData = async (resetPage = false) => {
  if (resetPage) {
    choseReportPagination.current = 1
  }
  const queryParam = {
    page: choseReportPagination.current,
    pageSize: choseReportPagination.pageSize,
    param: {
      name: taskNameValue.value,
      workspaceId: workspaceNameValue.value,
      dockSn: dockNameValue.value,
      status: 3
    }
  }
  const res = await getPlanPage(queryParam)
  if (res && res.code === 0) {
    choseData.value = res.data.list
    choseReportPagination.total = res.data.pagination.total

    // 数据加载后，如果有上次选择记录，尝试恢复选中状态
    if (lastSelectedRowKeys.value.length > 0) {
      selectedRows.value = choseData.value.filter(item =>
        lastSelectedRowKeys.value.includes(item.id)
      )
    }
  }
}

const fetchChoseReportData = async (resetPage = false) => {
  if (resetPage) {
    choseReportPagination.current = 1
  }
  // 创建映射关系：前端选择 -> 后端参数
  const periodTypeMapping: Record<string, string> = {
    daily: 'single', // 日报 -> single
    weekly: 'daily', // 周报 -> daily
    monthly: 'weekly', // 月报 -> weekly
    quarterly: 'monthly', // 季报 -> monthly
    yearly: 'quarterly' // 年报 -> quarterly
  }

  // 获取对应的periodType
  const periodType = periodTypeMapping[uploadReportState.time] || uploadReportState.time
  const [startMoment, endMoment] = reportDataTime.value
  const startStr = startMoment ? startMoment.format('YYYY-MM-DD') + ' 00:00:00' : ''
  const endStr = endMoment ? endMoment.format('YYYY-MM-DD') + ' 23:59:59' : ''

  const queryParam = {
    page: choseReportPagination.current,
    pageSize: choseReportPagination.pageSize,
    param: {
      periodType: periodType,
      status: 0,
      name: reportNameValue.value,
      startTime: startStr,
      endTime: endStr
    }
  }

  const res = await getReportPage(queryParam)
  if (res && res.code === 0) {
    choseData.value = res.data.list
    choseReportPagination.total = res.data.pagination.total

    // 数据加载后，如果有上次选择记录，尝试恢复选中状态
    if (lastSelectedRowKeys.value.length > 0) {
      selectedRows.value = choseData.value.filter(item =>
        lastSelectedRowKeys.value.includes(item.id)
      )
    }
  }
}

const beforeUpload = (file: File): boolean => {
  const isPDF = file.type === 'application/pdf' || file.name.endsWith('.pdf')
  if (!isPDF) {
    message.error('只能上传PDF文件!')
    return false
  }
}

const customUpload = async (options: any) => {
  const { file, onProgress, onSuccess, onError } = options

  try {
    uploadProgress.value = 0

    // 模拟上传进度
    const interval = setInterval(() => {
      if (uploadProgress.value < 90) {
        uploadProgress.value += 10
        onProgress({ percent: uploadProgress.value })
      }
    }, 200)

    const formData = new FormData()
    formData.append('file', file)
    formData.append('path', 'report/pdf') // 根据实际需求调整path

    const result = await getObjectKey(formData)

    clearInterval(interval)
    uploadProgress.value = 100
    onProgress({ percent: 100 })

    // 保存文件信息和objectKey
    uploadReportState.file = file
    uploadReportState.objectKey = result.data // 根据实际接口响应调整

    onSuccess(result, file)

    message.success('文件上传成功！')
  } catch (error) {
    message.error('文件上传失败！')
    onError(error)
    uploadProgress.value = 0
  }
}

const handleRemove = (): boolean => {
  uploadReportState.file = null
  uploadReportState.fileList = []
  return true
}

const getWaylinesTaskList = async () => {
  const res = await getFlyTaskList({})
  waylineList.value = res.data
}

const handlePeriodSelect = async ({ key }: { key: string }) => {
  uploadReportState.time = key
  uploadReportState.wayline = undefined
  uploadReportState.waylineName = ''
  selectedRowKeys.value = []
  selectedRows.value = []
  lastSelectedRows.value = []
  lastSelectedRowKeys.value = []
  uploadReportVisible.value = true
  // await getWaylineTaskList()
  await getEnabledTemplatesValue()
}

const flyUploadSubmit = async () => {
  await uploadReportRef.value.validate()

  if (!uploadReportState.file && !uploadReportState.objectKey) {
    message.error('请上传文件')
    return
  }

  // 对于周期报告，传递周期类型和逗号分隔的report_id
  const res = await getUploadReport({
    name: uploadReportState.name,
    version: uploadReportState.version,
    type: uploadReportState.type,
    object_key: uploadReportState.objectKey,
    period_type: uploadReportState.time, // 直接传递时间周期类型
    related_report_ids: uploadReportState.wayline // 逗号分隔的report_id
  })
  if (res.code === 0) {
    message.success('任务报告上传成功')
    uploadReportVisible.value = false
    fetchData(true)
  } else {
    message.error('任务报告上传失败')
    throw new Error('上传失败') // 抛出错误以便在handleSubmit中finally执行清空
  }
}

const flyUploadCancel = () => {
  uploadReportVisible.value = false
  uploadReportRef.value.resetFields()
}

const handleSubmit = async () => {
  try {
    if (uploadReportState.time === 'single') {
      await flyUploadSingleSubmit()
    } else {
      await flyUploadSubmit()
    }
    clearModalContent()
  } catch (error) {
    console.error('提交失败', error)
  }
}

const clearModalContent = () => {
  // 重置表单
  uploadReportRef.value.resetFields()

  // 清空自定义状态
  uploadReportState.name = ''
  uploadReportState.version = 'V1.0'
  uploadReportState.type = undefined
  uploadReportState.time = 'single'
  uploadReportState.wayline = undefined
  uploadReportState.waylineName = ''
  uploadReportState.file = null
  uploadReportState.fileList = []
  uploadReportState.objectKey = ''

  // 清空上传进度
  uploadProgress.value = 0

  // 清空选择记录
  selectedRowKeys.value = []
  selectedRows.value = []

  // 清空上次选择记录
  lastSelectedRows.value = []
  lastSelectedRowKeys.value = []
}

const flyUploadSingleSubmit = async () => {
  await uploadReportRef.value.validate()

  if (!uploadReportState.file && !uploadReportState.objectKey) {
    message.error('请上传文件')
    return
  }

  const res = await getUploadReport({
    name: uploadReportState.name,
    version: uploadReportState.version,
    type: uploadReportState.type,
    object_key: uploadReportState.objectKey,
    period_type: 'single',
    job_id: uploadReportState.wayline
  })
  if (res.code === 0) {
    message.success('任务报告上传成功')
    uploadReportVisible.value = false
    fetchData(true)
  } else {
    message.error('任务报告上传失败')
    throw new Error('上传失败')
  }
}

const getEnabledTemplatesValue = async () => {
  const res = await getEnabledTemplates()
  enabledTemplatesValue.value = res.data
}

// 报告列表
const reportListVisible = ref(false)
const reportListData = ref([])
const currentJobId = ref('')

const reportStatus = {
  0: '正常',
  1: '作废'
}

const reportColumns = [
  { title: '报告名称', dataIndex: 'name', align: 'center' },
  { title: '报告版本号', dataIndex: 'version', align: 'center' },
  { title: '报告周期', dataIndex: 'period_type', key: 'periodType', align: 'center' },
  { title: '状态', dataIndex: 'status', key: 'status', align: 'center' },
  { title: '生成时间', dataIndex: 'create_time', align: 'center' },
  { title: '操作', dataIndex: 'action', key: 'action', align: 'center' }
]

const reportPaginationProp = reactive({
  pageSizeOptions: ['10', '20', '50', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
  pageSize: 10,
  current: 1,
  total: 0,
  showTotal: (total: number) => `总计 ${total} 条`
})

const openReportView = async (jobId) => {
  currentJobId.value = jobId
  reportListVisible.value = true
  fetchReportData()
}

const closeReportList = () => {
  currentJobId.value = ''
  reportListVisible.value = false
}

function refreshReportData (page: Pagination) {
  choseReportPagination.current = page?.current!
  choseReportPagination.pageSize = page?.pageSize!
  if (uploadReportState.time === 'single') {
    fetchPlanData(false)
  } else {
    fetchChoseReportData(false)
  }
}

const fetchReportData = async () => {
  const queryParam = {
    page: reportPaginationProp.current,
    pageSize: reportPaginationProp.pageSize,
    param: {
      jobId: currentJobId.value,
    }
  }
  const res = await getReportPage(queryParam)
  reportListData.value = res.data.list
  reportPaginationProp.total = res.data.pagination.total
  // console.log('res.data', res.data)
}

const refreshReportModalData = (page: Pagination) => {
  reportPaginationProp.current = page?.current!
  reportPaginationProp.pageSize = page?.pageSize!
  fetchReportData()
}

const reportDownload = (record) => {
  window.open(record.url, '_blank')
}

const mediaContentRef = ref()
const taskJobId = ref('')

const filePagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})

const onAlarmTask = async (record) => {
  taskJobId.value = record.job_id
  const queryParam = {
    page: filePagination.current,
    page_size: filePagination.pageSize,
    param: {
      job_id: taskJobId.value
    }
  }
  const res = await getAlarmPage(queryParam)

  const index = filePagination.current * filePagination.pageSize - filePagination.pageSize

  mediaContentRef.value.initData(res.data.list, index, taskJobId.value)
}

function formatTimestamp (
  timestamp: number | string,
  format = 'YYYY-MM-DD HH:mm:ss'
): string {
  try {
    // 确保输入是有效的
    if (timestamp === null || timestamp === undefined || timestamp === '') {
      return '无效时间'
    }

    // 转换为数字
    let ts = Number(timestamp)

    // 检查转换是否成功
    if (isNaN(ts)) {
      return '无效时间'
    }

    // 处理时间戳长度
    if (ts.toString().length === 10) {
      ts *= 1000 // 秒级转毫秒级
    } else if (ts.toString().length !== 13) {
      // 既不是10位也不是13位，可能是无效时间戳
      return '无效时间'
    }

    const date = new Date(ts)

    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      return '无效时间'
    }

    // 定义时间补零函数
    const padZero = (num: number) => num.toString().padStart(2, '0')

    // 提取时间字段
    const year = date.getFullYear()
    const month = padZero(date.getMonth() + 1)
    const day = padZero(date.getDate())
    const hours = padZero(date.getHours())
    const minutes = padZero(date.getMinutes())
    const seconds = padZero(date.getSeconds())

    // 替换格式化模板
    return format
      .replace('YYYY', year.toString())
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds)
  } catch (error) {
    console.error('时间格式化错误:', error)
    return '无效时间'
  }
}

// 日报
const dailyReportVisible = ref(false)
const reportActiveKey = ref('daily')
const dailyReportRef = ref()
const weeklyReportRef = ref()
const taskVisible = ref(false)
const taskData = ref([])

const submitButtonText = computed(() => {
  return reportActiveKey.value === 'daily' ? '生成日报' : '生成周报'
})

const dailyReportState = reactive({
  name: '', // 报告名称
  version: '', // 版本号
  time: '', // 日期
  device: null, // 设备SN
  quanJobId: '', // 全景任务ID
  quanJobName: '', // 全景任务名称（显示用）
  otherJobIds: '', // 其他任务ID（逗号分隔）
  otherJobNames: '' // 其他任务名称（可选）
})

const weeklyReportState = reactive({
  name: '', // 报告名称
  version: 'V1.0', // 版本号
  time: '', // 日期
  workspace: null,
  template: null
})

const isFormComplete = computed(() => {
  if (reportActiveKey.value === 'daily') {
    const { name, version, time, device, quanJobId, otherJobIds } = dailyReportState
    return !!(name && version && time && device && quanJobId && otherJobIds)
  } else {
    const { name, version, time, workspace, template } = weeklyReportState
    return !!(name && version && time && workspace && template)
  }
})

const dailyReportRules = {
  name: [{ required: true, message: '请输入报告名称', trigger: 'blur' }],
  version: [{ required: true, message: '请输入报告版本号', trigger: 'blur' }],
  time: [{ required: true, message: '请选择任务时间', trigger: 'blur' }],
  device: [{ required: true, message: '请选择任务设备', trigger: 'blur' }],
  quanJob: [{ required: true, message: '请选择全景任务', trigger: 'change' }],
}

const weeklyReportRules = {
  name: [{ required: true, message: '请输入报告名称', trigger: 'blur' }],
  version: [{ required: true, message: '请输入报告版本号', trigger: 'blur' }],
  time: [{ required: true, message: '请选择任务时间', trigger: 'blur' }],
  workspace: [{ required: true, message: '请选择项目', trigger: 'blur' }],
  template: [{ required: true, message: '请选择模板', trigger: 'blur' }],
}

const openDailyReportModal = () => {
  dailyReportVisible.value = true
  reportActiveKey.value = 'daily'
  getDockSN()
  dailyReportState.name = ''
  dailyReportState.version = ''
  dailyReportState.time = null
  dailyReportState.device = null
  dailyReportState.task = ''
  dailyReportState.taskName = ''

  weeklyReportState.name = ''
  weeklyReportState.version = 'V1.0'
  weeklyReportState.time = ''
  weeklyReportState.workspace = null
  weeklyReportState.template = null

  selectedTaskKeys.value = []
  selectedTaskRows.value = []
  lastSelectedTaskKeys.value = []
  lastSelectedTaskRows.value = []
}

const selectTask = () => {
  taskVisible.value = true
  if (lastSelectedTaskKeys.value.length > 0) {
    selectedTaskKeys.value = [...lastSelectedTaskKeys.value]
  } else if (dailyReportState.quanJobId) {
    selectedTaskKeys.value = [dailyReportState.quanJobId]
  } else {
    selectedTaskKeys.value = []
  }
  fetchTaskData()
}

const taskReportPagination = reactive({
  pageSizeOptions: ['10', '20', '50', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
  pageSize: 10,
  current: 1,
  total: 0,
  showTotal: (total: number) => `总计 ${total} 条`
})

const selectedTaskKeys = ref<string[]>([])
const selectedTaskRows = ref<string[]>([])

const lastSelectedTaskKeys = ref<string[]>([])
const lastSelectedTaskRows = ref<any[]>([])

const taskColumns = [
  { title: '任务名称', dataIndex: 'job_name', key: 'job_name', align: 'center' },
  { title: '航线名称', dataIndex: 'file_name', key: 'fileName', align: 'center' },
  { title: '主体名称', dataIndex: 'portion', key: 'portion', align: 'center' },
  { title: '机场名称', dataIndex: 'dock_name', key: 'dock_name', align: 'center' },
  { title: '机场SN', dataIndex: 'dock_sn', key: 'dock_sn', align: 'center' },
  { title: '任务时间', dataIndex: 'execute_time', key: 'execute_time', align: 'center' },
  { title: '媒体文件', key: 'media_upload', align: 'center' },
]

const rowTaskSelection = computed(() => {
  return {
    type: 'radio',
    selectedRowKeys: selectedTaskKeys.value,
    onChange: (selectedKeys: string[], selectedRowsData: any[]) => {
      selectedTaskKeys.value = selectedKeys
      selectedTaskRows.value = selectedRowsData
    },
    getCheckboxProps: (record: any) => ({
      disabled: formatMediaTaskStatus(record).text !== '上传成功'
    })
  }
})

function refreshTaskData (page: Pagination) {
  taskReportPagination.current = page?.current!
  taskReportPagination.pageSize = page?.pageSize!
  fetchTaskData()
}

const handleDateChange = () => {
  dailyReportState.quanJobId = ''
  dailyReportState.quanJobName = ''
  dailyReportState.otherJobIds = ''
  dailyReportState.otherJobNames = ''
  otherJobsBySpecialApp.value = []
  selectedTaskKeys.value = []
  selectedTaskRows.value = []
}

const handleDeviceChange = () => {
  dailyReportState.quanJobId = ''
  dailyReportState.quanJobName = ''
  dailyReportState.otherJobIds = ''
  dailyReportState.otherJobNames = ''
  otherJobsBySpecialApp.value = []
  selectedTaskKeys.value = []
  selectedTaskRows.value = []
}

const fetchTaskData = async () => {
  let executionTimeStart = ''
  let executionTimeEnd = ''

  if (dailyReportState.time) {
    const startOfDay = moment(dailyReportState.time).startOf('day')
    const endOfDay = moment(dailyReportState.time).endOf('day')
    executionTimeStart = startOfDay.format('YYYY-MM-DD HH:mm:ss')
    executionTimeEnd = endOfDay.format('YYYY-MM-DD HH:mm:ss')
  }
  const queryParam = {
    page: taskReportPagination.current,
    page_size: taskReportPagination.pageSize,
    param: {
      start_time: executionTimeStart,
      end_time: executionTimeEnd,
      dock_sn: dailyReportState.device,
      status: 3
    }
  }
  const res = await getWaylineTask(queryParam)
  taskData.value = res.data.list
  taskReportPagination.total = res.data.pagination.total
}

const dailyReportCancel = () => {
  dailyReportVisible.value = false
  dailyReportState.name = ''
  dailyReportState.version = ''
  dailyReportState.time = null
  dailyReportState.device = null
  dailyReportState.quanJobId = ''
  dailyReportState.quanJobName = ''
  dailyReportState.otherJobIds = ''
  dailyReportState.otherJobNames = ''

  weeklyReportState.name = ''
  weeklyReportState.version = 'V1.0'
  weeklyReportState.time = ''
  weeklyReportState.workspace = null
  weeklyReportState.template = null

  otherJobsBySpecialApp.value = []
  selectedTaskKeys.value = []
  selectedTaskRows.value = []
  lastSelectedTaskKeys.value = []
  lastSelectedTaskRows.value = []
}

const choseTaskSubmit = () => {
  if (selectedTaskKeys.value.length === 0) {
    message.error('请选择一个任务')
    return
  }

  const selectedJobId = selectedTaskKeys.value[0]
  const selectedTask = selectedTaskRows.value.length > 0
    ? selectedTaskRows.value[0]
    : taskData.value.find(task => task.job_id === selectedJobId)

  if (!selectedTask) {
    message.error('未找到选中的任务')
    return
  }

  dailyReportState.quanJobId = selectedTask.job_id
  dailyReportState.quanJobName = selectedTask.job_name

  lastSelectedTaskKeys.value = [selectedJobId]
  lastSelectedTaskRows.value = [selectedTask]

  taskVisible.value = false
}

const choseTaskCancel = () => {
  selectedTaskKeys.value = [...lastSelectedTaskKeys.value]
  selectedTaskRows.value = [...lastSelectedTaskRows.value]
  taskVisible.value = false
}

const handleRepertSubmit = () => {
  if (reportActiveKey.value === 'daily') {
    handleDailySubmit()
  } else {
    weeklyReportSubmit()
  }
}

const handleDailySubmit = async () => {
  try {
    await dailyReportRef.value.validate()
    const specialApp: Record<string, string[]> = {}
    otherJobsBySpecialApp.value.forEach(group => {
      const jobIds = group.jobs.map(job => job.jobId)
      specialApp[group.specialAppCode] = jobIds
    })
    const param = {
      file_name: dailyReportState.name,
      sql_params: {
        quanJobId: dailyReportState.quanJobId,
        jobId: dailyReportState.otherJobIds || '',
        periodType: 'daily',
        specialApp: specialApp
      },
      template_code: 'daily_report（AI）',
      version: dailyReportState.version
    }
    const res = await getDailyData(param)
    if (res && res.code === 0) {
      message.success('日报正在生成中，请稍后查看')
      dailyReportVisible.value = false
    } else {
      message.error(res?.message || '日报生成失败')
    }
  } catch (error) {
    console.error('日报提交失败:', error)
    if (error.errorFields) {
      message.error('请填写完整信息')
    }
  }
}

const weeklyReportSubmit = async () => {
  await weeklyReportRef.value.validate()
  const [startDate, endDate] = weeklyReportState.time
  const payload = {
    template_code: weeklyReportState.template,
    sql_params: {
      startDate,
      endDate,
      workspaceId: weeklyReportState.workspace,
      periodType: 'weekly'
    },
    file_name: weeklyReportState.name,
    version: weeklyReportState.version
  }
  const res = await exportTemplateWeekReport(payload)
  if (res && res.code === 0) {
    message.success('周报正在生成中，请稍后查看')
    dailyReportVisible.value = false
  } else {
    message.error(res?.message || '周报生成失败')
  }
}

const messageVisible = ref(false)
const previewMessage = ref([])

const messageWidth = computed(() => {
  return previewMessage.value?.status === TaskStatus.Success ? '70%' : '40%'
})

const openMessageData = async (record) => {
  messageVisible.value = true
  const res = await getWaylineTaskList(record.job_id)
  previewMessage.value = res.data
  getTrajectory(record)
}

// ========== 专题应用相关 ==========
// 其他任务分组数据
const otherJobsBySpecialApp = ref<Array<{
  specialAppId: string,
  specialAppCode: string,
  specialAppName: string,
  jobs: any[]
}>>([])

// 专题应用树数据
const specialAppTreeData = ref<any[]>([])
const selectedSpecialAppId = ref<string | null>(null)
const currentSpecialApp = ref<{ id: string, appCode: string, name: string } | null>(null)
const filterJobBySpecialApp = ref(false)
const specialAppJobDialogVisible = ref(false)
const specialAppJobDialogLoading = ref(false)
const specialAppJobConfirmLoading = ref(false)
const filteredSpecialAppJobList = ref<any[]>([])
const selectedSpecialAppJobKeys = ref<string[]>([])
const selectedSpecialAppJobs = ref<any[]>([])
const specialAppJobPagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50']
})

// 表格列定义
const specialAppJobColumns = [
  { title: '任务名称', dataIndex: 'name', key: 'name', width: 200 },
  { title: '机场名称', dataIndex: 'dockName', key: 'dockName', width: 150 },
  { title: '专题应用', dataIndex: 'portion', key: 'portion', width: 150 },
  { title: '任务状态', dataIndex: 'status', key: 'status', width: 100 },
  { title: '媒体文件', dataIndex: 'mediaCount', key: 'mediaCount', width: 120 }
]

const getStatusText = (status: number) => {
  const map: Record<number, string> = { 1: '待执行', 2: '执行中', 3: '已完成', 4: '已取消', 5: '已失败', 6: '已暂停' }
  return map[status] || '未知'
}

const getStatusColor = (status: number) => {
  const map: Record<number, string> = { 1: 'cyan', 2: 'blue', 3: 'green', 4: 'orange', 5: 'red', 6: 'default' }
  return map[status] || 'default'
}

const buildSpecialAppTree = async () => {
  try {
    const treeRes = await getAllSpecialTree()
    const thirdRes = await getAllSpecialData()
    const rawTreeData = treeRes.data || []
    const thirdNodes = thirdRes.data || []

    const childrenMap = new Map<string, any[]>()
    thirdNodes.forEach(node => {
      const category = node.category
      if (!childrenMap.has(category)) {
        childrenMap.set(category, [])
      }
      childrenMap.get(category)!.push({
        key: node.appCode,
        title: node.appName,
        value: node.appCode,
        appCode: node.appCode,
        isLeaf: true,
        disabled: !node.appCode, // 【新增】没有 appCode 的节点不可选
        rawData: node
      })
    })

    const convertTree = (nodes: any[]): any[] => {
      return nodes.map(node => {
        const hasChildren = node.children && node.children.length > 0
        const matchedThird = !hasChildren ? (childrenMap.get(node.code) || []) : []
        const treeNode: any = {
          key: node.code,
          title: node.name,
          value: node.code,
          disabled: true,
          children: hasChildren ? convertTree(node.children) : matchedThird
        }
        return treeNode
      })
    }

    specialAppTreeData.value = convertTree(rawTreeData)
  } catch (error) {
    console.error('加载专题应用树失败', error)
    message.error('加载专题应用树失败')
  }
}

const openSpecialAppJobDialog = () => {
  if (!dailyReportState.time || !dailyReportState.device) {
    message.warning('请先选择日期和设备')
    return
  }
  // 确保已加载专题树
  if (specialAppTreeData.value.length === 0) {
    buildSpecialAppTree().then(() => {
      openSpecialAppDialogInternal()
    })
  } else {
    openSpecialAppDialogInternal()
  }
}

const openSpecialAppDialogInternal = () => {
  selectedSpecialAppId.value = null
  currentSpecialApp.value = null
  selectedSpecialAppJobKeys.value = []
  selectedSpecialAppJobs.value = []
  filteredSpecialAppJobList.value = []
  specialAppJobPagination.current = 1
  filterJobBySpecialApp.value = false
  specialAppJobDialogVisible.value = true
  // 加载任务列表（不筛选专题应用）
  fetchSpecialAppJobList()
}

const fetchSpecialAppJobList = async () => {
  if (!dailyReportState.time || !dailyReportState.device) return
  specialAppJobDialogLoading.value = true

  // 使用 .valueOf() 获取毫秒级时间戳
  const startOfDay = moment(dailyReportState.time).startOf('day').valueOf()
  const endOfDay = moment(dailyReportState.time).endOf('day').valueOf()

  const params: any = {
    page: specialAppJobPagination.current,
    page_size: specialAppJobPagination.pageSize,
    param: {
      executionTimeStart: startOfDay,
      executionTimeEnd: endOfDay,
      dockSn: dailyReportState.device,
      status: 3,
      notInJobIds: getAllSelectedJobIds(),
      hasSpecialAppCode: true
    }
  }
  if (selectedSpecialAppId.value) {
    const findNode = (nodes: any[], key: string): any => {
      for (const node of nodes) {
        if (node.key === key) return node
        if (node.children) {
          const found = findNode(node.children, key)
          if (found) return found
        }
      }
      return null
    }
    const node = findNode(specialAppTreeData.value, selectedSpecialAppId.value)
    if (node && node.appCode) {
      params.param.specialAppCode = node.appCode
    } else {
      message.warning('选择的专题应用无效（缺少 appCode）')
      specialAppJobDialogLoading.value = false
      return
    }
  }
  try {
    const res = await getPlanPage(params)
    filteredSpecialAppJobList.value = res.data.list
    specialAppJobPagination.total = res.data.pagination.total
  } catch (error) {
    message.error('加载任务列表失败')
  } finally {
    specialAppJobDialogLoading.value = false
  }
}

// 获取所有已选择的任务ID（全景任务 + 其他任务）
const getAllSelectedJobIds = (): string[] => {
  const ids: string[] = []
  if (dailyReportState.quanJobId) {
    ids.push(dailyReportState.quanJobId)
  }
  if (dailyReportState.otherJobIds) {
    ids.push(...dailyReportState.otherJobIds.split(','))
  }
  return ids
}

const handleSpecialAppSelectChange = (value: string) => {
  if (!value) {
    currentSpecialApp.value = null
    selectedSpecialAppJobKeys.value = []
    return
  }
  // 从树中查找节点
  const findNode = (nodes: any[], key: string): any => {
    for (const node of nodes) {
      if (node.key === key) return node
      if (node.children) {
        const found = findNode(node.children, key)
        if (found) return found
      }
    }
    return null
  }
  const node = findNode(specialAppTreeData.value, value)
  if (!node || !node.isLeaf || !node.appCode) {
    message.warning('请选择有效的专题应用（最后一层且含appCode）')
    selectedSpecialAppId.value = null
    return
  }
  // 检查是否已添加
  if (otherJobsBySpecialApp.value.some(g => g.specialAppId === node.key)) {
    message.warning('该专题应用已被选择')
    selectedSpecialAppId.value = null
    return
  }
  currentSpecialApp.value = {
    id: node.appCode,
    appCode: node.appCode,
    name: node.title
  }
  console.log('currentSpecialApp.value', currentSpecialApp.value, currentSpecialApp.value.appCode)
  selectedSpecialAppJobKeys.value = []
  selectedSpecialAppJobs.value = []
  specialAppJobPagination.current = 1
  fetchSpecialAppJobList()
}

const handleSpecialAppJobTableChange = (pagination: any) => {
  specialAppJobPagination.current = pagination.current
  specialAppJobPagination.pageSize = pagination.pageSize
  fetchSpecialAppJobList()
}

const onSpecialAppJobSelectChange = (selectedRowKeys: string[], selectedRows: any[]) => {
  selectedSpecialAppJobKeys.value = selectedRowKeys
  selectedSpecialAppJobs.value = selectedRows
}

const confirmSpecialAppJob = async () => {
  if (selectedSpecialAppJobs.value.length === 0) {
    message.warning('请至少选择一个任务')
    return
  }

  // 检查任务是否已被添加（全景任务或其他场景任务）
  const duplicate = selectedSpecialAppJobs.value.some(job => {
    const jobId = job.job_id || job.id
    return getAllSelectedJobIds().includes(jobId)
  })
  if (duplicate) {
    message.warning('选中的任务中有些已被添加，请重新选择')
    return
  }

  if (currentSpecialApp.value) {
    if (otherJobsBySpecialApp.value.some(g => g.specialAppId === currentSpecialApp.value.id)) {
      message.warning(`专题应用“${currentSpecialApp.value.name}”已被选择，请先移除或更换`)
      return
    }
    otherJobsBySpecialApp.value.push({
      specialAppId: currentSpecialApp.value.id,
      specialAppCode: currentSpecialApp.value.appCode,
      specialAppName: currentSpecialApp.value.name,
      jobs: [...selectedSpecialAppJobs.value]
    })
  } else {
    const groups = groupJobsBySpecialApp(selectedSpecialAppJobs.value)
    // 检查每个分组是否已存在
    for (const group of groups) {
      if (otherJobsBySpecialApp.value.some(g => g.specialAppId === group.specialAppId)) {
        message.warning(`专题应用“${group.specialAppName}”已有任务，请取消勾选该组任务或先移除已有分组`)
        return
      }
    }
    otherJobsBySpecialApp.value.push(...groups)
  }

  updateDailyReportJobIds()
  specialAppJobDialogVisible.value = false
  message.success('添加成功')
}

const groupJobsBySpecialApp = (jobs: any[]) => {
  const groupsMap = new Map<string, {
    specialAppId: string,
    specialAppCode: string,
    specialAppName: string,
    jobs: any[]
  }>()

  jobs.forEach(job => {
    // 使用 portion 作为分组键，若为空则用任务 ID 确保独立
    const appName = job.portion || '未分类'
    const key = job.portion ? job.portion : `job-${job.jobId || job.id}`

    if (!groupsMap.has(key)) {
      groupsMap.set(key, {
        specialAppId: key,
        specialAppCode: job.portion_code || '',
        specialAppName: appName,
        jobs: []
      })
    }
    groupsMap.get(key)!.jobs.push(job)
  })

  return Array.from(groupsMap.values())
}

const updateDailyReportJobIds = () => {
  const ids: string[] = []
  const names: string[] = []
  otherJobsBySpecialApp.value.forEach(group => {
    group.jobs.forEach(job => {
      ids.push(job.jobId)
      names.push(job.name || job.job_name)
    })
  })
  dailyReportState.otherJobIds = ids.join(',')
  dailyReportState.otherJobNames = names.join('、')
}

const removeSpecialAppGroup = (index: number) => {
  otherJobsBySpecialApp.value.splice(index, 1)
  updateDailyReportJobIds()
}

const removeJobFromGroup = (groupIndex: number, job: any) => {
  const group = otherJobsBySpecialApp.value[groupIndex]
  const jobId = job.job_id || job.id
  group.jobs = group.jobs.filter(j => (j.job_id || j.id) !== jobId)
  if (group.jobs.length === 0) {
    otherJobsBySpecialApp.value.splice(groupIndex, 1)
  }
  updateDailyReportJobIds()
}

onMounted(() => {
  fetchData(false)
  reset()
  getDockSN()
  loadTaskTypeDataList()
  dataVerify()
  fetchRecentlyTask()
  getWorkspaceLists()
  getTemplateList()
})

</script>

<style lang="scss" scoped>
:deep(.ant-table-body) {
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.plan-panel{
  width: 100%;
  padding: 16px;
}

.plan-panel-wrapper {
  // width: 100%;
  // padding: 16px;
  .plan-table {
    background: #fff;
    // margin-top: 10px;
  }
  .action-area {

     &:deep(.ant-btn) {
        margin-right: 10px;
        margin-bottom: 10px;
      }
  }

  .circle-icon {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 3px;
    border-radius: 50%;
    vertical-align: middle;
    flex-shrink: 0;
  }
}
.header {
  width: 100%;
  height: 60px;
  background: #fff;
  padding: 16px;
  font-size: 20px;
  font-weight: bold;
  text-align: start;
  color: #000;
}

.header-mar {
  margin: 20px 20px 0 20px;
}

.flex-row {
  white-space: pre-wrap;
}

.json-container {
  height: 535px;
  background-color: #f5f5f5;
  border-radius: 4px;
  .map{
    width: 100%;
    height: 535px;
    position: relative;
  }
}

.report-containers {
  display: flex;
  width: 100%;
  background: #fff;
  margin: 20px 10px 10px 10px;
}

.report-item {
  display: flex;
  flex-direction: column;
  gap: 0;
  background: #fff;
  margin-right: 4%;
}

.report-title {
  background-color: #2c3e50;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 4px 4px 0 0;
}

.template-overflow {
  height: 600px;
  overflow-y: auto;
  border-top: 1px solid #e1e4e8;
  border-bottom: 1px solid #e1e4e8;
}

.report-card {
  background-color: #fff;
  border: 1px solid #e1e4e8;
  border-top: none;
  border-radius: 0 0 4px 4px;
  padding: 16px;
  flex: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

/* 模板卡片：flex实现左右排布 */
.template-card {
  display: flex;
  align-items: center; /* 图片与文本垂直居中 */
  padding: 12px;
  margin-bottom: 15px;
  border: 1px solid #f0f2f5;
  border-radius: 4px;
  background: #fafbfc;
  transition: all 0.3s;
  cursor: pointer;
  gap: 12px; /* 图片与文本的间距 */
}

.template-card-active {
  border-color: #1890ff; /* 选中边框色：阿里云蓝色 */
  background: #e6f7ff; /* 选中背景色：淡蓝色 */
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.template-card:hover:not(.template-card-active) {
  border-color: #2c3e50;
  background: #fff;
  box-shadow: 0 2px 4px rgba(44, 62, 80, 0.1);
}

/* 图片区域：固定宽度 */
.template-left {
  width: 60px; /* 图片宽度 */
  flex-shrink: 0; /* 不压缩 */
}

.template-thumb {
  width: 100%;
  height: 90px; /* 图片高度（与宽度一致，正方形） */
  background-color: #e9ecef;
  border-radius: 4px;
}

.thumb-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  color: #6c757d;
  padding: 4px;
}

.selected-tag {
  width: 24px;
  height: 24px;
  background-color: #1890ff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  bottom: 4px;
  right: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 文本区域：自适应宽度 */
.template-right {
  flex: 1; /* 占满剩余宽度 */
  overflow: hidden; /* 防止文本溢出 */
}

.template-name {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.template-desc {
  font-size: 12px;
  color: #6c757d;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* 最多显示2行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.report-info-wrapper {
  background: #fff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 模块标题：突出显示，底部分割线 */
.module-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937; /* 黑色系文字 */
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

/* 表单行：左右布局 */
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 16px;
}

/* 表单标签：固定宽度，右对齐 */
.form-label {
  width: 80px;
  font-size: 14px;
  color: #4b5563; /* 深灰色文字 */
  text-align: right;
  flex-shrink: 0;
}

/* 表单控件容器：占满剩余宽度 */
.form-control {
  flex: 1;
}

.button-container {
  display: flex;
  justify-content: flex-end; /* 让按钮靠右侧 */
}

.preview-container {
  width: 100%;
  height: 600px;
  border: 1px solid #e1e4e8;
  border-radius: 4px;
  overflow: auto;
  background-color: #fff;
  position: relative;
}

.preview-loading {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}

.loading-text {
  margin-top: 16px;
  font-size: 14px;
  color: #6c757d;
}

.preview-content {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.preview-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #9ca3af;
  background-color: #fafafa;
}

.detail-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3px;
  }
}

.detail-section {
  background: #fafafa;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #f0f0f0;
  flex: 1;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.right-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &.full-width {
    grid-column: 1 / -1;
  }
}

.detail-label {
  font-size: 14px;
  color: #8c8c8c;
  font-weight: 400;
  line-height: 1.4;
}

.detail-value {
  font-size: 14px;
  color: #262626;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-word;
}

.recently-body {
  width: 100%;
  height: calc(100vh - 240px); /* 根据实际布局调整高度 */
  overflow-y: auto;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #f0f0f0;

  // 统一列宽（使用 grid 或 flex，这里用 grid 更稳健）
  .recently-header,
  .task-row {
    display: grid;
    grid-template-columns: 160px 120px 1fr 100px 100px 1fr 120px 1fr 1fr;
    gap: 8px;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 13px;
  }

  .recently-header {
    position: sticky;
    top: 0;
    background: #fafafa;
    font-weight: 600;
    color: #1f2d3d;
    z-index: 10;
    border-bottom: 1px solid #e8e8e8;
  }

  .task-row {
    background: #fff;
    transition: background 0.2s;
    &:hover {
      background: #f5f7fa;
    }
  }

  .date-group-title {
    // 保留原风格的全部样式
    background: #f9fafc;
    font-weight: 500;
    padding: 8px 16px;
    margin-top: 8px;
    border-left: 4px solid #2d8cf0;
    color: #1f2d3d;
    font-size: 14px;
    position: sticky;
    top: 42px;        // 使日期标题在表头下方固定
    background-color: #f9fafc;
    z-index: 9;

    // 新增交互样式（不影响原有视觉）
    cursor: pointer;
    user-select: none;
    transition: background 0.2s;

    &:hover {
      background: #eef2f6;  // 鼠标悬停时轻微变色，提升体验
    }

    .expand-icon {
      margin-right: 8px;
      font-size: 12px;
      vertical-align: middle;
    }
  }

  .col-plan-time {
    div {
      line-height: 1.4;
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .col-status,
  .col-media {
    // display: flex;
    flex-direction: column;
    gap: 4px;
    .circle-icon {
      width: 8px;
      height: 8px;
      display: inline-block;
      margin-right: 6px;
      border-radius: 50%;
    }
    .flex-display {
      align-items: center;
    }

  }

  .col-action {
    display: flex;
  }

  .col-name,
  .col-topic,
  .col-route,
  .col-dock {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .empty-row,
  .empty-data {
    padding: 30px;
    text-align: center;
    color: #bfcbd9;
    font-size: 13px;
  }
}

// 调整操作图标样式
.action-area .fz18 {
  font-size: 18px;
}
.c189 {
  color: #1890ff;
  cursor: pointer;
}
.ml5 {
  margin-left: 5px;
}

.other-tasks-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.special-app-group {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 12px;
  background: #fafafa;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.group-title {
  font-weight: 600;
  color: #262626;
}

.group-jobs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.special-app-dialog-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.special-app-section {
  padding: 0;
}

.job-section {
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;
}

.section-title {
  font-weight: 500;
  margin-bottom: 12px;
  color: #262626;
}

.subtitle {
  font-weight: normal;
  color: #8c8c8c;
  font-size: 12px;
  margin-left: 8px;
}

.selected-app-info {
  margin-top: 12px;
  padding: 8px 12px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  color: #1890ff;
}

:deep(.ant-select-tree-treenode) {
  /* 所有节点默认不高亮、灰字 */
  .ant-select-tree-node-content-wrapper {
    color: rgba(0, 0, 0, 0.45);
  }
}

/* 可选节点（有 appCode 的叶子节点）高亮 */
:deep(.ant-select-tree-treenode:not(.ant-select-tree-treenode-disabled)) {
  .ant-select-tree-node-content-wrapper {
    color: #1890ff;
    font-weight: 500;
  }

  &:hover .ant-select-tree-node-content-wrapper {
    background-color: #e6f7ff !important;
  }
}

:deep(.ant-select-tree-treenode) {
  .ant-select-tree-node-content-wrapper {
    color: rgba(0, 0, 0, 0.45);   // 所有节点默认灰色
  }
}
:deep(.ant-select-tree-treenode:not(.ant-select-tree-treenode-disabled)) {
  .ant-select-tree-node-content-wrapper {
    color: #1890ff;                // 可选节点（第三层且有 appCode）为蓝色
    font-weight: 500;
  }
}

// 编辑名称容器
.edit-name-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.edit-name-input {
  flex: 1;
  min-width: 0;
}

.edit-icon {
  font-size: 16px;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s;

  &.save-icon {
    color: #52c41a;

    &:hover:not(.icon-disabled) {
      transform: scale(1.2);
    }
  }

  &.cancel-icon {
    color: #ff4d4f;

    &:hover {
      transform: scale(1.2);
    }
  }

  &.icon-disabled {
    color: #d9d9d9;
    cursor: not-allowed;
  }
}

.col-name {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: visible;

  .edit-name-wrapper {
    width: 100%;
  }
}
</style>
